import * as zod from "zod";

/**
 * @summary Get Plan Results Endpoint
 */
export const GetPlanResultsParams = zod.object({
  tenant_name: zod.string(),
  plan_id: zod.int(),
});

export const GetPlanResultsQueryParams = zod.object({
  period: zod.int(),
});

export const getPlanResultsResponsePeriodsMixesItemProductionItemNumHeatsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsRecipeMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsScrapMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDriMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTappedMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsBilletMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemProductionItemNumHeatsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsRecipeMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsScrapMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDriMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTappedMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsBilletMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemCostPerHeatMaterialsMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemRecipeMassMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemScrapMassMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemDriMassMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemTappedMassMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemTargetTappedMassLowerMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemBilletMassMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemYieldPercentMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemYieldPercentBilletsMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemDisplayProducedMassMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemDisplayYieldPercentMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemPeriodExclusiveMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemNumHeatsExclusiveMin = 0;

export const getPlanResultsResponseSummaryPeriodSummaryItemTotalCostMaterialsMin = 0;

export const getPlanResultsResponseSummaryPeriodMaterialSummaryItemPeriodExclusiveMin = 0;

export const getPlanResultsResponseSummaryPeriodMaterialSummaryItemMassConsumedMin = 0;

export const getPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainableObtainedMin = 0;

export const getPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainedPricePerTonneOneMin = 0;

export const getPlanResultsResponseSummaryPeriodMaterialSummaryItemCostPerTonneMaterialMin = 0;

export const getPlanResultsResponseSummaryPeriodMaterialSummaryItemCostConsumedMin = 0;

export const getPlanResultsResponseSteelGradeSetNameMax = 255;

export const getPlanResultsResponseSteelGradeSetSteelGradesItemChemicalConstraintsItemCoefficientsItemChemicalElementSymbolMax = 2;

export const getPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMin = 0;
export const getPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMax = 1;

export const GetPlanResultsResponse = zod
  .object({
    plan_id: zod.int(),
    optimisation_status: zod.enum([
      "not_started",
      "failed",
      "failed_suboptimal",
      "succeeded_suboptimal",
      "succeeded",
      "edited",
    ]),
    periods: zod.record(
      zod.string(),
      zod.object({
        period_index: zod.int(),
        mixes: zod.array(
          zod.object({
            name: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            production: zod.array(
              zod.object({
                steel_grade_name: zod.string(),
                num_heats: zod
                  .int()
                  .min(
                    getPlanResultsResponsePeriodsMixesItemProductionItemNumHeatsMin
                  ),
              })
            ),
            num_heats: zod.int(),
            mix: zod.object({
              baskets: zod.array(
                zod.object({
                  basket_number: zod.int(),
                  layers: zod.array(
                    zod.object({
                      material_name: zod.string(),
                      quantity: zod.object({
                        value: zod.number(),
                        unit: zod
                          .enum(["mass", "ratio", "grab"])
                          .describe(
                            "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                          ),
                      }),
                      layer_number: zod.int(),
                      layer_group_id: zod
                        .union([zod.int(), zod.null()])
                        .optional()
                        .describe(
                          "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                        ),
                    })
                  ),
                })
              ),
              furnace: zod.array(
                zod.object({
                  material_name: zod.string(),
                  quantity: zod.object({
                    value: zod.number(),
                    unit: zod
                      .enum(["mass", "ratio", "grab"])
                      .describe(
                        "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                      ),
                  }),
                })
              ),
              thresholds: zod.union([
                zod.array(
                  zod.object({
                    material_name: zod.string(),
                    upper: zod.union([zod.number(), zod.null()]),
                    lower: zod.union([zod.number(), zod.null()]),
                    unit: zod
                      .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                      .describe(
                        "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                      ),
                  })
                ),
                zod.null(),
              ]),
              id: zod.int(),
              basket_totals: zod.array(
                zod.object({
                  material_name: zod.string(),
                  mass: zod.number(),
                })
              ),
              summary: zod.union([
                zod.object({
                  physics: zod.object({
                    recipe_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsRecipeMassMin
                      ),
                    scrap_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsScrapMassMin
                      ),
                    dri_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDriMassMin
                      ),
                    tapped_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTappedMassMin
                      ),
                    target_tapped_mass_lower: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTargetTappedMassLowerMin
                      ),
                    billet_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsBilletMassMin
                      ),
                    yield_percent: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentMin
                      ),
                    yield_percent_billets: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentBilletsMin
                      ),
                    display_produced_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayProducedMassMin
                      )
                      .describe(
                        "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                      ),
                    display_yield_percent: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayYieldPercentMin
                      )
                      .describe(
                        "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                      ),
                  }),
                  chemistry: zod.array(
                    zod.object({
                      constraint_name: zod.string(),
                      ordering: zod.int(),
                      weight_percent_loc: zod.number(),
                      weight_percent_scale: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemWeightPercentScaleMin
                        ),
                      steel_grade_risks: zod.array(
                        zod.object({
                          steel_grade_id: zod.int(),
                          weight_percent_min_tolerance: zod.union([
                            zod
                              .number()
                              .min(
                                getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                              ),
                            zod.null(),
                          ]),
                          weight_percent_max_tolerance: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                            ),
                          expected_over_tolerance_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                            ),
                          expected_under_tolerance_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                            ),
                          warning_level_failure_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                            ),
                          error_level_failure_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                            ),
                        })
                      ),
                      quantiles: zod.array(
                        zod.object({
                          quantile: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemQuantilesItemQuantileMin
                            ),
                          weight_percent: zod.number(),
                        })
                      ),
                    })
                  ),
                  cost: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  cost_per_target_mass: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  basket_summaries: zod.array(
                    zod.object({
                      chef_group_name: zod.string(),
                      basket_number: zod
                        .int()
                        .gt(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                        ),
                      recipe_mass: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemRecipeMassMin
                        ),
                      volume: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemVolumeMin
                        ),
                      fullness: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemFullnessMin
                        ),
                      min_fill_level: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinFillLevelMin
                        ),
                      max_fill_level: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxFillLevelMin
                        ),
                      min_mass: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinMassMin
                        ),
                      max_mass: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxMassMin
                        ),
                      basket_volume: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketVolumeMin
                        ),
                    })
                  ),
                }),
                zod.null(),
              ]),
            }),
          })
        ),
        materials: zod.array(
          zod.object({
            material: zod.string(),
            label: zod.string(),
            quantity: zod.number(),
            min_quantity: zod.number(),
            max_quantity: zod.union([zod.number(), zod.null()]),
            specific_price: zod.number(),
          })
        ),
        product_group_results: zod.array(
          zod.object({
            name: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            production: zod.array(
              zod.object({
                steel_grade_name: zod.string(),
                num_heats: zod
                  .int()
                  .min(
                    getPlanResultsResponsePeriodsProductGroupResultsItemProductionItemNumHeatsMin
                  ),
              })
            ),
            num_heats: zod.int(),
            mix: zod.object({
              baskets: zod.array(
                zod.object({
                  basket_number: zod.int(),
                  layers: zod.array(
                    zod.object({
                      material_name: zod.string(),
                      quantity: zod.object({
                        value: zod.number(),
                        unit: zod
                          .enum(["mass", "ratio", "grab"])
                          .describe(
                            "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                          ),
                      }),
                      layer_number: zod.int(),
                      layer_group_id: zod
                        .union([zod.int(), zod.null()])
                        .optional()
                        .describe(
                          "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                        ),
                    })
                  ),
                })
              ),
              furnace: zod.array(
                zod.object({
                  material_name: zod.string(),
                  quantity: zod.object({
                    value: zod.number(),
                    unit: zod
                      .enum(["mass", "ratio", "grab"])
                      .describe(
                        "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                      ),
                  }),
                })
              ),
              thresholds: zod.union([
                zod.array(
                  zod.object({
                    material_name: zod.string(),
                    upper: zod.union([zod.number(), zod.null()]),
                    lower: zod.union([zod.number(), zod.null()]),
                    unit: zod
                      .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                      .describe(
                        "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                      ),
                  })
                ),
                zod.null(),
              ]),
              id: zod.int(),
              basket_totals: zod.array(
                zod.object({
                  material_name: zod.string(),
                  mass: zod.number(),
                })
              ),
              summary: zod.union([
                zod.object({
                  physics: zod.object({
                    recipe_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsRecipeMassMin
                      ),
                    scrap_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsScrapMassMin
                      ),
                    dri_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDriMassMin
                      ),
                    tapped_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTappedMassMin
                      ),
                    target_tapped_mass_lower: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTargetTappedMassLowerMin
                      ),
                    billet_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsBilletMassMin
                      ),
                    yield_percent: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentMin
                      ),
                    yield_percent_billets: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentBilletsMin
                      ),
                    display_produced_mass: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayProducedMassMin
                      )
                      .describe(
                        "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                      ),
                    display_yield_percent: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayYieldPercentMin
                      )
                      .describe(
                        "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                      ),
                  }),
                  chemistry: zod.array(
                    zod.object({
                      constraint_name: zod.string(),
                      ordering: zod.int(),
                      weight_percent_loc: zod.number(),
                      weight_percent_scale: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemWeightPercentScaleMin
                        ),
                      steel_grade_risks: zod.array(
                        zod.object({
                          steel_grade_id: zod.int(),
                          weight_percent_min_tolerance: zod.union([
                            zod
                              .number()
                              .min(
                                getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                              ),
                            zod.null(),
                          ]),
                          weight_percent_max_tolerance: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                            ),
                          expected_over_tolerance_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                            ),
                          expected_under_tolerance_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                            ),
                          warning_level_failure_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                            ),
                          error_level_failure_rate_percent: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                            ),
                        })
                      ),
                      quantiles: zod.array(
                        zod.object({
                          quantile: zod
                            .number()
                            .min(
                              getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin
                            ),
                          weight_percent: zod.number(),
                        })
                      ),
                    })
                  ),
                  cost: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  cost_per_target_mass: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  basket_summaries: zod.array(
                    zod.object({
                      chef_group_name: zod.string(),
                      basket_number: zod
                        .int()
                        .gt(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                        ),
                      recipe_mass: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemRecipeMassMin
                        ),
                      volume: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemVolumeMin
                        ),
                      fullness: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemFullnessMin
                        ),
                      min_fill_level: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinFillLevelMin
                        ),
                      max_fill_level: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin
                        ),
                      min_mass: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinMassMin
                        ),
                      max_mass: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxMassMin
                        ),
                      basket_volume: zod
                        .number()
                        .min(
                          getPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketVolumeMin
                        ),
                    })
                  ),
                }),
                zod.null(),
              ]),
            }),
          })
        ),
      })
    ),
    slack_variable_usage: zod.array(
      zod.object({
        details: zod.record(
          zod.string(),
          zod.union([zod.string(), zod.number()])
        ),
        slack_variable: zod.enum([
          "unobtainium_purchased",
          "unobtainium_consumed",
          "material_period_exclusivity_constraint_violated",
          "target_inventory_increases",
          "target_inventory_decreases",
          "soft_material_max_increases",
          "soft_material_min_decreases",
          "soft_material_exclusivity_constraint_violated",
          "mix_use_count_increases",
          "impurity_weight_percent_max_increase",
          "impurity_weight_percent_min_decrease",
        ]),
        usage: zod.number(),
        period: zod.int(),
        cost: zod.number(),
      })
    ),
    summary: zod
      .object({
        period_summary: zod.array(
          zod.object({
            cost_per_heat_materials: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemCostPerHeatMaterialsMin
              ),
            cost_per_heat_electrical_energy: zod.number(),
            cost_per_tonne_tapped_materials: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneTappedMaterialsMin
              ),
            cost_per_tonne_tapped_electrical_energy: zod.number(),
            cost_per_tonne_billets_materials: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneBilletsMaterialsMin
              ),
            cost_per_tonne_billets_electrical_energy: zod.number(),
            cost_per_heat: zod.number(),
            cost_per_tonne_tapped: zod.number(),
            cost_per_tonne_billets: zod.number(),
            display_cost_per_tonne_materials: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMaterialsMin
              )
              .describe(
                "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
              ),
            display_cost_per_tonne_electrical_energy: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneElectricalEnergyMin
              )
              .describe(
                "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
              ),
            display_cost_per_tonne: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMin
              )
              .describe(
                "The total cost per tonne to display in the frontend. "
              ),
            cost_per_tonne_charged_materials: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneChargedMaterialsMin
              ),
            cost_per_tonne_charged_electrical_energy: zod.number(),
            cost_per_tonne_charged: zod.number(),
            recipe_mass: zod
              .number()
              .min(getPlanResultsResponseSummaryPeriodSummaryItemRecipeMassMin),
            scrap_mass: zod
              .number()
              .min(getPlanResultsResponseSummaryPeriodSummaryItemScrapMassMin),
            dri_mass: zod
              .number()
              .min(getPlanResultsResponseSummaryPeriodSummaryItemDriMassMin),
            tapped_mass: zod
              .number()
              .min(getPlanResultsResponseSummaryPeriodSummaryItemTappedMassMin),
            target_tapped_mass_lower: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemTargetTappedMassLowerMin
              ),
            billet_mass: zod
              .number()
              .min(getPlanResultsResponseSummaryPeriodSummaryItemBilletMassMin),
            yield_percent: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemYieldPercentMin
              ),
            yield_percent_billets: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemYieldPercentBilletsMin
              ),
            display_produced_mass: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemDisplayProducedMassMin
              )
              .describe(
                "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
              ),
            display_yield_percent: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemDisplayYieldPercentMin
              )
              .describe(
                "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
              ),
            period: zod
              .int()
              .gt(
                getPlanResultsResponseSummaryPeriodSummaryItemPeriodExclusiveMin
              ),
            name: zod.union([zod.string(), zod.null()]),
            is_deployable: zod.boolean(),
            start_timestamp: zod.union([
              zod.iso.datetime({ offset: true }),
              zod.null(),
            ]),
            end_timestamp: zod.union([
              zod.iso.datetime({ offset: true }),
              zod.null(),
            ]),
            num_heats: zod
              .int()
              .gt(
                getPlanResultsResponseSummaryPeriodSummaryItemNumHeatsExclusiveMin
              ),
            total_cost_materials: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodSummaryItemTotalCostMaterialsMin
              ),
            total_cost_electrical_energy: zod.number(),
            total_cost: zod.number(),
          })
        ),
        period_material_summary: zod.array(
          zod.object({
            period: zod
              .int()
              .gt(
                getPlanResultsResponseSummaryPeriodMaterialSummaryItemPeriodExclusiveMin
              ),
            material: zod.string(),
            initial_inventory: zod
              .number()
              .describe(
                "The initial inventory at the start of the period, not counting any obtainable acquired during the period. (Can be negative due to unobtainium.)"
              ),
            final_inventory: zod
              .number()
              .describe(
                "The inventory at the end of the period, after the obtainable has been added and consumption subtracted. (Can be negative due to unobtainium)."
              ),
            mass_consumed: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodMaterialSummaryItemMassConsumedMin
              )
              .describe("The mass consumed of the material in the period"),
            obtainable_obtained: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainableObtainedMin
              )
              .describe("The mass of material obtained during the period"),
            obtainable_remaining: zod
              .number()
              .describe(
                "The mass of material that could have been obtained in the period but was not. (Can be negative due to unobtainium.)"
              ),
            obtained_price_per_tonne: zod
              .union([
                zod
                  .number()
                  .min(
                    getPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainedPricePerTonneOneMin
                  ),
                zod.null(),
              ])
              .describe(
                "The price per unit mass of the material obtained during the period. Null if no material was obtained"
              ),
            cost_per_tonne_material: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodMaterialSummaryItemCostPerTonneMaterialMin
              )
              .describe(
                "The material cost per unit mass of the material consumed in the period"
              ),
            cost_per_tonne_electrical_energy: zod
              .number()
              .describe(
                "The electrical energy cost per unit mass of the material consumed in the period. (Can be negative due to negative energy prices)."
              ),
            cost_consumed: zod
              .number()
              .min(
                getPlanResultsResponseSummaryPeriodMaterialSummaryItemCostConsumedMin
              )
              .describe(
                "The total material cost in the period (not including electrical energy)"
              ),
          })
        ),
      })
      .describe("Summary attached to name-based results."),
    metadata: zod.object({
      base_plan_id: zod.int(),
      parent_plan_id: zod.union([zod.int(), zod.null()]),
      created_by_name: zod.string(),
      created_at: zod.iso.datetime({ offset: true }),
      plan_type: zod.enum(["base", "edited", "fallback"]),
    }),
    start_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    end_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    steel_grade_set: zod.object({
      id: zod.int(),
      name: zod.string().min(1).max(getPlanResultsResponseSteelGradeSetNameMax),
      created_at: zod.iso.datetime({ offset: true }),
      created_by_id: zod.string(),
      steel_grades: zod.array(
        zod.object({
          id: zod.int(),
          name: zod.string(),
          chemical_constraints: zod.array(
            zod.object({
              weight_percent_min: zod
                .union([zod.number(), zod.null()])
                .optional(),
              weight_percent_max: zod.number(),
              adjusted_weight_percent_max: zod.number(),
              max_failure_rate: zod.number(),
              coefficients: zod.array(
                zod.object({
                  chemical_element: zod.object({
                    id: zod.int(),
                    name: zod.string(),
                    symbol: zod
                      .string()
                      .max(
                        getPlanResultsResponseSteelGradeSetSteelGradesItemChemicalConstraintsItemCoefficientsItemChemicalElementSymbolMax
                      ),
                    status: zod.enum(["modelled", "visible", "unused"]),
                    ordering: zod.int(),
                  }),
                  coefficient: zod.number(),
                })
              ),
              name: zod.union([zod.string(), zod.null()]).optional(),
            })
          ),
          fraction_of_heats: zod
            .number()
            .min(
              getPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMin
            )
            .max(
              getPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMax
            ),
        })
      ),
    }),
  })
  .describe("ResultsRead extended with the plan-level metadata.");

/**
 * @summary Get Plan Results Batch Endpoint
 */
export const GetPlanResultsBatchParams = zod.object({
  tenant_name: zod.string(),
});

export const GetPlanResultsBatchBodyItem = zod.object({
  plan_id: zod.int(),
  period: zod.int(),
});
export const GetPlanResultsBatchBody = zod.array(GetPlanResultsBatchBodyItem);

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemProductionItemNumHeatsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsRecipeMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsScrapMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsDriMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsTappedMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsBilletMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsYieldPercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemProductionItemNumHeatsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsRecipeMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsScrapMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsDriMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsTappedMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsBilletMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerHeatMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerTonneTappedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerTonneBilletsMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayCostPerTonneMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayCostPerTonneElectricalEnergyMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayCostPerTonneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerTonneChargedMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemRecipeMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemScrapMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDriMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemTappedMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemTargetTappedMassLowerMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemBilletMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemYieldPercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemYieldPercentBilletsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayProducedMassMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayYieldPercentMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemPeriodExclusiveMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemNumHeatsExclusiveMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemTotalCostMaterialsMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemPeriodExclusiveMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemMassConsumedMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemObtainableObtainedMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemObtainedPricePerTonneOneMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemCostPerTonneMaterialMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemCostConsumedMin = 0;

export const getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetNameMax = 255;

export const getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetSteelGradesItemChemicalConstraintsItemCoefficientsItemChemicalElementSymbolMax = 2;

export const getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetSteelGradesItemFractionOfHeatsMin = 0;
export const getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetSteelGradesItemFractionOfHeatsMax = 1;

export const GetPlanResultsBatchResponse = zod.object({
  results: zod.array(
    zod.object({
      plan_id: zod.int(),
      period: zod.int(),
      response: zod.union([
        zod
          .object({
            plan_id: zod.int(),
            optimisation_status: zod.enum([
              "not_started",
              "failed",
              "failed_suboptimal",
              "succeeded_suboptimal",
              "succeeded",
              "edited",
            ]),
            periods: zod.record(
              zod.string(),
              zod.object({
                period_index: zod.int(),
                mixes: zod.array(
                  zod.object({
                    name: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    production: zod.array(
                      zod.object({
                        steel_grade_name: zod.string(),
                        num_heats: zod
                          .int()
                          .min(
                            getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemProductionItemNumHeatsMin
                          ),
                      })
                    ),
                    num_heats: zod.int(),
                    mix: zod.object({
                      baskets: zod.array(
                        zod.object({
                          basket_number: zod.int(),
                          layers: zod.array(
                            zod.object({
                              material_name: zod.string(),
                              quantity: zod.object({
                                value: zod.number(),
                                unit: zod
                                  .enum(["mass", "ratio", "grab"])
                                  .describe(
                                    "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                                  ),
                              }),
                              layer_number: zod.int(),
                              layer_group_id: zod
                                .union([zod.int(), zod.null()])
                                .optional()
                                .describe(
                                  "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                                ),
                            })
                          ),
                        })
                      ),
                      furnace: zod.array(
                        zod.object({
                          material_name: zod.string(),
                          quantity: zod.object({
                            value: zod.number(),
                            unit: zod
                              .enum(["mass", "ratio", "grab"])
                              .describe(
                                "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                              ),
                          }),
                        })
                      ),
                      thresholds: zod.union([
                        zod.array(
                          zod.object({
                            material_name: zod.string(),
                            upper: zod.union([zod.number(), zod.null()]),
                            lower: zod.union([zod.number(), zod.null()]),
                            unit: zod
                              .enum([
                                "grabs",
                                "mass",
                                "fraction",
                                "ratio_tolerance",
                              ])
                              .describe(
                                "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                              ),
                          })
                        ),
                        zod.null(),
                      ]),
                      id: zod.int(),
                      basket_totals: zod.array(
                        zod.object({
                          material_name: zod.string(),
                          mass: zod.number(),
                        })
                      ),
                      summary: zod.union([
                        zod.object({
                          physics: zod.object({
                            recipe_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsRecipeMassMin
                              ),
                            scrap_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsScrapMassMin
                              ),
                            dri_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsDriMassMin
                              ),
                            tapped_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsTappedMassMin
                              ),
                            target_tapped_mass_lower: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsTargetTappedMassLowerMin
                              ),
                            billet_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsBilletMassMin
                              ),
                            yield_percent: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsYieldPercentMin
                              ),
                            yield_percent_billets: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsYieldPercentBilletsMin
                              ),
                            display_produced_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsDisplayProducedMassMin
                              )
                              .describe(
                                "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                              ),
                            display_yield_percent: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOnePhysicsDisplayYieldPercentMin
                              )
                              .describe(
                                "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                              ),
                          }),
                          chemistry: zod.array(
                            zod.object({
                              constraint_name: zod.string(),
                              ordering: zod.int(),
                              weight_percent_loc: zod.number(),
                              weight_percent_scale: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemWeightPercentScaleMin
                                ),
                              steel_grade_risks: zod.array(
                                zod.object({
                                  steel_grade_id: zod.int(),
                                  weight_percent_min_tolerance: zod.union([
                                    zod
                                      .number()
                                      .min(
                                        getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                                      ),
                                    zod.null(),
                                  ]),
                                  weight_percent_max_tolerance: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                                    ),
                                  expected_over_tolerance_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                                    ),
                                  expected_under_tolerance_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                                    ),
                                  warning_level_failure_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                                    ),
                                  error_level_failure_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                                    ),
                                })
                              ),
                              quantiles: zod.array(
                                zod.object({
                                  quantile: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneChemistryItemQuantilesItemQuantileMin
                                    ),
                                  weight_percent: zod.number(),
                                })
                              ),
                            })
                          ),
                          cost: zod.object({
                            cost_per_heat_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerHeatMaterialsMin
                              ),
                            cost_per_heat_electrical_energy: zod.number(),
                            cost_per_tonne_tapped_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerTonneTappedMaterialsMin
                              ),
                            cost_per_tonne_tapped_electrical_energy:
                              zod.number(),
                            cost_per_tonne_billets_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                              ),
                            cost_per_tonne_billets_electrical_energy:
                              zod.number(),
                            cost_per_heat: zod.number(),
                            cost_per_tonne_tapped: zod.number(),
                            cost_per_tonne_billets: zod.number(),
                            display_cost_per_tonne_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                              )
                              .describe(
                                "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                              ),
                            display_cost_per_tonne_electrical_energy: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                              )
                              .describe(
                                "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                              ),
                            display_cost_per_tonne: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMin
                              )
                              .describe(
                                "The total cost per tonne to display in the frontend. "
                              ),
                            cost_per_tonne_charged_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostCostPerTonneChargedMaterialsMin
                              ),
                            cost_per_tonne_charged_electrical_energy:
                              zod.number(),
                            cost_per_tonne_charged: zod.number(),
                          }),
                          cost_per_target_mass: zod.object({
                            cost_per_heat_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                              ),
                            cost_per_heat_electrical_energy: zod.number(),
                            cost_per_tonne_tapped_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                              ),
                            cost_per_tonne_tapped_electrical_energy:
                              zod.number(),
                            cost_per_tonne_billets_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                              ),
                            cost_per_tonne_billets_electrical_energy:
                              zod.number(),
                            cost_per_heat: zod.number(),
                            cost_per_tonne_tapped: zod.number(),
                            cost_per_tonne_billets: zod.number(),
                            display_cost_per_tonne_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                              )
                              .describe(
                                "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                              ),
                            display_cost_per_tonne_electrical_energy: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                              )
                              .describe(
                                "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                              ),
                            display_cost_per_tonne: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                              )
                              .describe(
                                "The total cost per tonne to display in the frontend. "
                              ),
                            cost_per_tonne_charged_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                              ),
                            cost_per_tonne_charged_electrical_energy:
                              zod.number(),
                            cost_per_tonne_charged: zod.number(),
                          }),
                          basket_summaries: zod.array(
                            zod.object({
                              chef_group_name: zod.string(),
                              basket_number: zod
                                .int()
                                .gt(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                                ),
                              recipe_mass: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemRecipeMassMin
                                ),
                              volume: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemVolumeMin
                                ),
                              fullness: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemFullnessMin
                                ),
                              min_fill_level: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMinFillLevelMin
                                ),
                              max_fill_level: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxFillLevelMin
                                ),
                              min_mass: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMinMassMin
                                ),
                              max_mass: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxMassMin
                                ),
                              basket_volume: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketVolumeMin
                                ),
                            })
                          ),
                        }),
                        zod.null(),
                      ]),
                    }),
                  })
                ),
                materials: zod.array(
                  zod.object({
                    material: zod.string(),
                    label: zod.string(),
                    quantity: zod.number(),
                    min_quantity: zod.number(),
                    max_quantity: zod.union([zod.number(), zod.null()]),
                    specific_price: zod.number(),
                  })
                ),
                product_group_results: zod.array(
                  zod.object({
                    name: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    production: zod.array(
                      zod.object({
                        steel_grade_name: zod.string(),
                        num_heats: zod
                          .int()
                          .min(
                            getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemProductionItemNumHeatsMin
                          ),
                      })
                    ),
                    num_heats: zod.int(),
                    mix: zod.object({
                      baskets: zod.array(
                        zod.object({
                          basket_number: zod.int(),
                          layers: zod.array(
                            zod.object({
                              material_name: zod.string(),
                              quantity: zod.object({
                                value: zod.number(),
                                unit: zod
                                  .enum(["mass", "ratio", "grab"])
                                  .describe(
                                    "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                                  ),
                              }),
                              layer_number: zod.int(),
                              layer_group_id: zod
                                .union([zod.int(), zod.null()])
                                .optional()
                                .describe(
                                  "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                                ),
                            })
                          ),
                        })
                      ),
                      furnace: zod.array(
                        zod.object({
                          material_name: zod.string(),
                          quantity: zod.object({
                            value: zod.number(),
                            unit: zod
                              .enum(["mass", "ratio", "grab"])
                              .describe(
                                "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                              ),
                          }),
                        })
                      ),
                      thresholds: zod.union([
                        zod.array(
                          zod.object({
                            material_name: zod.string(),
                            upper: zod.union([zod.number(), zod.null()]),
                            lower: zod.union([zod.number(), zod.null()]),
                            unit: zod
                              .enum([
                                "grabs",
                                "mass",
                                "fraction",
                                "ratio_tolerance",
                              ])
                              .describe(
                                "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                              ),
                          })
                        ),
                        zod.null(),
                      ]),
                      id: zod.int(),
                      basket_totals: zod.array(
                        zod.object({
                          material_name: zod.string(),
                          mass: zod.number(),
                        })
                      ),
                      summary: zod.union([
                        zod.object({
                          physics: zod.object({
                            recipe_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsRecipeMassMin
                              ),
                            scrap_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsScrapMassMin
                              ),
                            dri_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsDriMassMin
                              ),
                            tapped_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsTappedMassMin
                              ),
                            target_tapped_mass_lower: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsTargetTappedMassLowerMin
                              ),
                            billet_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsBilletMassMin
                              ),
                            yield_percent: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentMin
                              ),
                            yield_percent_billets: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentBilletsMin
                              ),
                            display_produced_mass: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayProducedMassMin
                              )
                              .describe(
                                "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                              ),
                            display_yield_percent: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayYieldPercentMin
                              )
                              .describe(
                                "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                              ),
                          }),
                          chemistry: zod.array(
                            zod.object({
                              constraint_name: zod.string(),
                              ordering: zod.int(),
                              weight_percent_loc: zod.number(),
                              weight_percent_scale: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemWeightPercentScaleMin
                                ),
                              steel_grade_risks: zod.array(
                                zod.object({
                                  steel_grade_id: zod.int(),
                                  weight_percent_min_tolerance: zod.union([
                                    zod
                                      .number()
                                      .min(
                                        getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                                      ),
                                    zod.null(),
                                  ]),
                                  weight_percent_max_tolerance: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                                    ),
                                  expected_over_tolerance_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                                    ),
                                  expected_under_tolerance_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                                    ),
                                  warning_level_failure_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                                    ),
                                  error_level_failure_rate_percent: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                                    ),
                                })
                              ),
                              quantiles: zod.array(
                                zod.object({
                                  quantile: zod
                                    .number()
                                    .min(
                                      getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin
                                    ),
                                  weight_percent: zod.number(),
                                })
                              ),
                            })
                          ),
                          cost: zod.object({
                            cost_per_heat_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerHeatMaterialsMin
                              ),
                            cost_per_heat_electrical_energy: zod.number(),
                            cost_per_tonne_tapped_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin
                              ),
                            cost_per_tonne_tapped_electrical_energy:
                              zod.number(),
                            cost_per_tonne_billets_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                              ),
                            cost_per_tonne_billets_electrical_energy:
                              zod.number(),
                            cost_per_heat: zod.number(),
                            cost_per_tonne_tapped: zod.number(),
                            cost_per_tonne_billets: zod.number(),
                            display_cost_per_tonne_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                              )
                              .describe(
                                "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                              ),
                            display_cost_per_tonne_electrical_energy: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                              )
                              .describe(
                                "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                              ),
                            display_cost_per_tonne: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMin
                              )
                              .describe(
                                "The total cost per tonne to display in the frontend. "
                              ),
                            cost_per_tonne_charged_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin
                              ),
                            cost_per_tonne_charged_electrical_energy:
                              zod.number(),
                            cost_per_tonne_charged: zod.number(),
                          }),
                          cost_per_target_mass: zod.object({
                            cost_per_heat_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                              ),
                            cost_per_heat_electrical_energy: zod.number(),
                            cost_per_tonne_tapped_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                              ),
                            cost_per_tonne_tapped_electrical_energy:
                              zod.number(),
                            cost_per_tonne_billets_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                              ),
                            cost_per_tonne_billets_electrical_energy:
                              zod.number(),
                            cost_per_heat: zod.number(),
                            cost_per_tonne_tapped: zod.number(),
                            cost_per_tonne_billets: zod.number(),
                            display_cost_per_tonne_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                              )
                              .describe(
                                "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                              ),
                            display_cost_per_tonne_electrical_energy: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                              )
                              .describe(
                                "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                              ),
                            display_cost_per_tonne: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                              )
                              .describe(
                                "The total cost per tonne to display in the frontend. "
                              ),
                            cost_per_tonne_charged_materials: zod
                              .number()
                              .min(
                                getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                              ),
                            cost_per_tonne_charged_electrical_energy:
                              zod.number(),
                            cost_per_tonne_charged: zod.number(),
                          }),
                          basket_summaries: zod.array(
                            zod.object({
                              chef_group_name: zod.string(),
                              basket_number: zod
                                .int()
                                .gt(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                                ),
                              recipe_mass: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemRecipeMassMin
                                ),
                              volume: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemVolumeMin
                                ),
                              fullness: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemFullnessMin
                                ),
                              min_fill_level: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinFillLevelMin
                                ),
                              max_fill_level: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin
                                ),
                              min_mass: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinMassMin
                                ),
                              max_mass: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxMassMin
                                ),
                              basket_volume: zod
                                .number()
                                .min(
                                  getPlanResultsBatchResponseResultsItemResponseOnePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketVolumeMin
                                ),
                            })
                          ),
                        }),
                        zod.null(),
                      ]),
                    }),
                  })
                ),
              })
            ),
            slack_variable_usage: zod.array(
              zod.object({
                details: zod.record(
                  zod.string(),
                  zod.union([zod.string(), zod.number()])
                ),
                slack_variable: zod.enum([
                  "unobtainium_purchased",
                  "unobtainium_consumed",
                  "material_period_exclusivity_constraint_violated",
                  "target_inventory_increases",
                  "target_inventory_decreases",
                  "soft_material_max_increases",
                  "soft_material_min_decreases",
                  "soft_material_exclusivity_constraint_violated",
                  "mix_use_count_increases",
                  "impurity_weight_percent_max_increase",
                  "impurity_weight_percent_min_decrease",
                ]),
                usage: zod.number(),
                period: zod.int(),
                cost: zod.number(),
              })
            ),
            summary: zod
              .object({
                period_summary: zod.array(
                  zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                    recipe_mass: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemRecipeMassMin
                      ),
                    scrap_mass: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemScrapMassMin
                      ),
                    dri_mass: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDriMassMin
                      ),
                    tapped_mass: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemTappedMassMin
                      ),
                    target_tapped_mass_lower: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemTargetTappedMassLowerMin
                      ),
                    billet_mass: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemBilletMassMin
                      ),
                    yield_percent: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemYieldPercentMin
                      ),
                    yield_percent_billets: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemYieldPercentBilletsMin
                      ),
                    display_produced_mass: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayProducedMassMin
                      )
                      .describe(
                        "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                      ),
                    display_yield_percent: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemDisplayYieldPercentMin
                      )
                      .describe(
                        "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                      ),
                    period: zod
                      .int()
                      .gt(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemPeriodExclusiveMin
                      ),
                    name: zod.union([zod.string(), zod.null()]),
                    is_deployable: zod.boolean(),
                    start_timestamp: zod.union([
                      zod.iso.datetime({ offset: true }),
                      zod.null(),
                    ]),
                    end_timestamp: zod.union([
                      zod.iso.datetime({ offset: true }),
                      zod.null(),
                    ]),
                    num_heats: zod
                      .int()
                      .gt(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemNumHeatsExclusiveMin
                      ),
                    total_cost_materials: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodSummaryItemTotalCostMaterialsMin
                      ),
                    total_cost_electrical_energy: zod.number(),
                    total_cost: zod.number(),
                  })
                ),
                period_material_summary: zod.array(
                  zod.object({
                    period: zod
                      .int()
                      .gt(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemPeriodExclusiveMin
                      ),
                    material: zod.string(),
                    initial_inventory: zod
                      .number()
                      .describe(
                        "The initial inventory at the start of the period, not counting any obtainable acquired during the period. (Can be negative due to unobtainium.)"
                      ),
                    final_inventory: zod
                      .number()
                      .describe(
                        "The inventory at the end of the period, after the obtainable has been added and consumption subtracted. (Can be negative due to unobtainium)."
                      ),
                    mass_consumed: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemMassConsumedMin
                      )
                      .describe(
                        "The mass consumed of the material in the period"
                      ),
                    obtainable_obtained: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemObtainableObtainedMin
                      )
                      .describe(
                        "The mass of material obtained during the period"
                      ),
                    obtainable_remaining: zod
                      .number()
                      .describe(
                        "The mass of material that could have been obtained in the period but was not. (Can be negative due to unobtainium.)"
                      ),
                    obtained_price_per_tonne: zod
                      .union([
                        zod
                          .number()
                          .min(
                            getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemObtainedPricePerTonneOneMin
                          ),
                        zod.null(),
                      ])
                      .describe(
                        "The price per unit mass of the material obtained during the period. Null if no material was obtained"
                      ),
                    cost_per_tonne_material: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemCostPerTonneMaterialMin
                      )
                      .describe(
                        "The material cost per unit mass of the material consumed in the period"
                      ),
                    cost_per_tonne_electrical_energy: zod
                      .number()
                      .describe(
                        "The electrical energy cost per unit mass of the material consumed in the period. (Can be negative due to negative energy prices)."
                      ),
                    cost_consumed: zod
                      .number()
                      .min(
                        getPlanResultsBatchResponseResultsItemResponseOneSummaryPeriodMaterialSummaryItemCostConsumedMin
                      )
                      .describe(
                        "The total material cost in the period (not including electrical energy)"
                      ),
                  })
                ),
              })
              .describe("Summary attached to name-based results."),
            metadata: zod.object({
              base_plan_id: zod.int(),
              parent_plan_id: zod.union([zod.int(), zod.null()]),
              created_by_name: zod.string(),
              created_at: zod.iso.datetime({ offset: true }),
              plan_type: zod.enum(["base", "edited", "fallback"]),
            }),
            start_at: zod.union([
              zod.iso.datetime({ offset: true }),
              zod.null(),
            ]),
            end_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            steel_grade_set: zod.object({
              id: zod.int(),
              name: zod
                .string()
                .min(1)
                .max(
                  getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetNameMax
                ),
              created_at: zod.iso.datetime({ offset: true }),
              created_by_id: zod.string(),
              steel_grades: zod.array(
                zod.object({
                  id: zod.int(),
                  name: zod.string(),
                  chemical_constraints: zod.array(
                    zod.object({
                      weight_percent_min: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      weight_percent_max: zod.number(),
                      adjusted_weight_percent_max: zod.number(),
                      max_failure_rate: zod.number(),
                      coefficients: zod.array(
                        zod.object({
                          chemical_element: zod.object({
                            id: zod.int(),
                            name: zod.string(),
                            symbol: zod
                              .string()
                              .max(
                                getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetSteelGradesItemChemicalConstraintsItemCoefficientsItemChemicalElementSymbolMax
                              ),
                            status: zod.enum(["modelled", "visible", "unused"]),
                            ordering: zod.int(),
                          }),
                          coefficient: zod.number(),
                        })
                      ),
                      name: zod.union([zod.string(), zod.null()]).optional(),
                    })
                  ),
                  fraction_of_heats: zod
                    .number()
                    .min(
                      getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetSteelGradesItemFractionOfHeatsMin
                    )
                    .max(
                      getPlanResultsBatchResponseResultsItemResponseOneSteelGradeSetSteelGradesItemFractionOfHeatsMax
                    ),
                })
              ),
            }),
          })
          .describe("ResultsRead extended with the plan-level metadata."),
        zod.null(),
      ]),
    })
  ),
});

/**
 * @summary Get Deployed Plans
 */
export const GetDeployedPlansParams = zod.object({
  tenant_name: zod.string(),
});

export const GetDeployedPlansQueryParams = zod.object({
  deployment_types: zod
    .union([
      zod.array(
        zod.enum([
          "standard",
          "edited_standard",
          "backup",
          "edited_backup",
          "purchasing_plan",
        ])
      ),
      zod.null(),
    ])
    .optional(),
});

export const GetDeployedPlansResponse = zod.object({
  latest: zod.union([zod.int(), zod.null()]),
  next: zod.union([zod.int(), zod.null()]),
});

/**
 * @summary Get Deployed Plan Results Endpoint
 */
export const GetDeployedPlanResultsParams = zod.object({
  tenant_name: zod.string(),
  plan_id: zod.union([zod.int(), zod.enum(["latest"]), zod.enum(["next"])]),
});

export const GetDeployedPlanResultsQueryParams = zod.object({
  period: zod.int(),
  deployment_types: zod
    .union([
      zod.array(
        zod.enum([
          "standard",
          "edited_standard",
          "backup",
          "edited_backup",
          "purchasing_plan",
        ])
      ),
      zod.null(),
    ])
    .optional(),
});

export const getDeployedPlanResultsResponsePeriodsMixesItemProductionItemNumHeatsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsRecipeMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsScrapMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDriMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTappedMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsBilletMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemProductionItemNumHeatsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsRecipeMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsScrapMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDriMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTappedMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsBilletMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerHeatMaterialsMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneTappedMaterialsMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneBilletsMaterialsMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMaterialsMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneElectricalEnergyMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneChargedMaterialsMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemRecipeMassMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemScrapMassMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemDriMassMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemTappedMassMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemTargetTappedMassLowerMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemBilletMassMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemYieldPercentMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemYieldPercentBilletsMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayProducedMassMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayYieldPercentMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemPeriodExclusiveMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemNumHeatsExclusiveMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodSummaryItemTotalCostMaterialsMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemPeriodExclusiveMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemMassConsumedMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainableObtainedMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainedPricePerTonneOneMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemCostPerTonneMaterialMin = 0;

export const getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemCostConsumedMin = 0;

export const getDeployedPlanResultsResponseSteelGradeSetNameMax = 255;

export const getDeployedPlanResultsResponseSteelGradeSetSteelGradesItemChemicalConstraintsItemCoefficientsItemChemicalElementSymbolMax = 2;

export const getDeployedPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMin = 0;
export const getDeployedPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMax = 1;

export const GetDeployedPlanResultsResponse = zod.object({
  plan_id: zod.int(),
  optimisation_status: zod.enum([
    "not_started",
    "failed",
    "failed_suboptimal",
    "succeeded_suboptimal",
    "succeeded",
    "edited",
  ]),
  periods: zod.record(
    zod.string(),
    zod.object({
      period_index: zod.int(),
      mixes: zod.array(
        zod.object({
          name: zod.string(),
          description: zod.union([zod.string(), zod.null()]),
          production: zod.array(
            zod.object({
              steel_grade_name: zod.string(),
              num_heats: zod
                .int()
                .min(
                  getDeployedPlanResultsResponsePeriodsMixesItemProductionItemNumHeatsMin
                ),
            })
          ),
          num_heats: zod.int(),
          mix: zod.object({
            baskets: zod.array(
              zod.object({
                basket_number: zod.int(),
                layers: zod.array(
                  zod.object({
                    material_name: zod.string(),
                    quantity: zod.object({
                      value: zod.number(),
                      unit: zod
                        .enum(["mass", "ratio", "grab"])
                        .describe(
                          "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                        ),
                    }),
                    layer_number: zod.int(),
                    layer_group_id: zod
                      .union([zod.int(), zod.null()])
                      .optional()
                      .describe(
                        "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                      ),
                  })
                ),
              })
            ),
            furnace: zod.array(
              zod.object({
                material_name: zod.string(),
                quantity: zod.object({
                  value: zod.number(),
                  unit: zod
                    .enum(["mass", "ratio", "grab"])
                    .describe(
                      "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                    ),
                }),
              })
            ),
            thresholds: zod.union([
              zod.array(
                zod.object({
                  material_name: zod.string(),
                  upper: zod.union([zod.number(), zod.null()]),
                  lower: zod.union([zod.number(), zod.null()]),
                  unit: zod
                    .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                    .describe(
                      "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                    ),
                })
              ),
              zod.null(),
            ]),
            id: zod.int(),
            basket_totals: zod.array(
              zod.object({
                material_name: zod.string(),
                mass: zod.number(),
              })
            ),
            summary: zod.union([
              zod.object({
                physics: zod.object({
                  recipe_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsRecipeMassMin
                    ),
                  scrap_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsScrapMassMin
                    ),
                  dri_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDriMassMin
                    ),
                  tapped_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTappedMassMin
                    ),
                  target_tapped_mass_lower: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsTargetTappedMassLowerMin
                    ),
                  billet_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsBilletMassMin
                    ),
                  yield_percent: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentMin
                    ),
                  yield_percent_billets: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsYieldPercentBilletsMin
                    ),
                  display_produced_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayProducedMassMin
                    )
                    .describe(
                      "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                    ),
                  display_yield_percent: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOnePhysicsDisplayYieldPercentMin
                    )
                    .describe(
                      "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                    ),
                }),
                chemistry: zod.array(
                  zod.object({
                    constraint_name: zod.string(),
                    ordering: zod.int(),
                    weight_percent_loc: zod.number(),
                    weight_percent_scale: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemWeightPercentScaleMin
                      ),
                    steel_grade_risks: zod.array(
                      zod.object({
                        steel_grade_id: zod.int(),
                        weight_percent_min_tolerance: zod.union([
                          zod
                            .number()
                            .min(
                              getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                            ),
                          zod.null(),
                        ]),
                        weight_percent_max_tolerance: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                          ),
                        expected_over_tolerance_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                          ),
                        expected_under_tolerance_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                          ),
                        warning_level_failure_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                          ),
                        error_level_failure_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                          ),
                      })
                    ),
                    quantiles: zod.array(
                      zod.object({
                        quantile: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneChemistryItemQuantilesItemQuantileMin
                          ),
                        weight_percent: zod.number(),
                      })
                    ),
                  })
                ),
                cost: zod.object({
                  cost_per_heat_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerHeatMaterialsMin
                    ),
                  cost_per_heat_electrical_energy: zod.number(),
                  cost_per_tonne_tapped_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneTappedMaterialsMin
                    ),
                  cost_per_tonne_tapped_electrical_energy: zod.number(),
                  cost_per_tonne_billets_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                    ),
                  cost_per_tonne_billets_electrical_energy: zod.number(),
                  cost_per_heat: zod.number(),
                  cost_per_tonne_tapped: zod.number(),
                  cost_per_tonne_billets: zod.number(),
                  display_cost_per_tonne_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                    )
                    .describe(
                      "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                    ),
                  display_cost_per_tonne_electrical_energy: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                    )
                    .describe(
                      "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                    ),
                  display_cost_per_tonne: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostDisplayCostPerTonneMin
                    )
                    .describe(
                      "The total cost per tonne to display in the frontend. "
                    ),
                  cost_per_tonne_charged_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostCostPerTonneChargedMaterialsMin
                    ),
                  cost_per_tonne_charged_electrical_energy: zod.number(),
                  cost_per_tonne_charged: zod.number(),
                }),
                cost_per_target_mass: zod.object({
                  cost_per_heat_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                    ),
                  cost_per_heat_electrical_energy: zod.number(),
                  cost_per_tonne_tapped_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                    ),
                  cost_per_tonne_tapped_electrical_energy: zod.number(),
                  cost_per_tonne_billets_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                    ),
                  cost_per_tonne_billets_electrical_energy: zod.number(),
                  cost_per_heat: zod.number(),
                  cost_per_tonne_tapped: zod.number(),
                  cost_per_tonne_billets: zod.number(),
                  display_cost_per_tonne_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                    )
                    .describe(
                      "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                    ),
                  display_cost_per_tonne_electrical_energy: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                    )
                    .describe(
                      "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                    ),
                  display_cost_per_tonne: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                    )
                    .describe(
                      "The total cost per tonne to display in the frontend. "
                    ),
                  cost_per_tonne_charged_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                    ),
                  cost_per_tonne_charged_electrical_energy: zod.number(),
                  cost_per_tonne_charged: zod.number(),
                }),
                basket_summaries: zod.array(
                  zod.object({
                    chef_group_name: zod.string(),
                    basket_number: zod
                      .int()
                      .gt(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                      ),
                    recipe_mass: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemRecipeMassMin
                      ),
                    volume: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemVolumeMin
                      ),
                    fullness: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemFullnessMin
                      ),
                    min_fill_level: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinFillLevelMin
                      ),
                    max_fill_level: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxFillLevelMin
                      ),
                    min_mass: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMinMassMin
                      ),
                    max_mass: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemMaxMassMin
                      ),
                    basket_volume: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsMixesItemMixSummaryOneBasketSummariesItemBasketVolumeMin
                      ),
                  })
                ),
              }),
              zod.null(),
            ]),
          }),
        })
      ),
      materials: zod.array(
        zod.object({
          material: zod.string(),
          label: zod.string(),
          quantity: zod.number(),
          min_quantity: zod.number(),
          max_quantity: zod.union([zod.number(), zod.null()]),
          specific_price: zod.number(),
        })
      ),
      product_group_results: zod.array(
        zod.object({
          name: zod.string(),
          description: zod.union([zod.string(), zod.null()]),
          production: zod.array(
            zod.object({
              steel_grade_name: zod.string(),
              num_heats: zod
                .int()
                .min(
                  getDeployedPlanResultsResponsePeriodsProductGroupResultsItemProductionItemNumHeatsMin
                ),
            })
          ),
          num_heats: zod.int(),
          mix: zod.object({
            baskets: zod.array(
              zod.object({
                basket_number: zod.int(),
                layers: zod.array(
                  zod.object({
                    material_name: zod.string(),
                    quantity: zod.object({
                      value: zod.number(),
                      unit: zod
                        .enum(["mass", "ratio", "grab"])
                        .describe(
                          "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                        ),
                    }),
                    layer_number: zod.int(),
                    layer_group_id: zod
                      .union([zod.int(), zod.null()])
                      .optional()
                      .describe(
                        "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                      ),
                  })
                ),
              })
            ),
            furnace: zod.array(
              zod.object({
                material_name: zod.string(),
                quantity: zod.object({
                  value: zod.number(),
                  unit: zod
                    .enum(["mass", "ratio", "grab"])
                    .describe(
                      "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                    ),
                }),
              })
            ),
            thresholds: zod.union([
              zod.array(
                zod.object({
                  material_name: zod.string(),
                  upper: zod.union([zod.number(), zod.null()]),
                  lower: zod.union([zod.number(), zod.null()]),
                  unit: zod
                    .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                    .describe(
                      "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                    ),
                })
              ),
              zod.null(),
            ]),
            id: zod.int(),
            basket_totals: zod.array(
              zod.object({
                material_name: zod.string(),
                mass: zod.number(),
              })
            ),
            summary: zod.union([
              zod.object({
                physics: zod.object({
                  recipe_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsRecipeMassMin
                    ),
                  scrap_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsScrapMassMin
                    ),
                  dri_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDriMassMin
                    ),
                  tapped_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTappedMassMin
                    ),
                  target_tapped_mass_lower: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsTargetTappedMassLowerMin
                    ),
                  billet_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsBilletMassMin
                    ),
                  yield_percent: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentMin
                    ),
                  yield_percent_billets: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsYieldPercentBilletsMin
                    ),
                  display_produced_mass: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayProducedMassMin
                    )
                    .describe(
                      "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                    ),
                  display_yield_percent: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOnePhysicsDisplayYieldPercentMin
                    )
                    .describe(
                      "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                    ),
                }),
                chemistry: zod.array(
                  zod.object({
                    constraint_name: zod.string(),
                    ordering: zod.int(),
                    weight_percent_loc: zod.number(),
                    weight_percent_scale: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemWeightPercentScaleMin
                      ),
                    steel_grade_risks: zod.array(
                      zod.object({
                        steel_grade_id: zod.int(),
                        weight_percent_min_tolerance: zod.union([
                          zod
                            .number()
                            .min(
                              getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                            ),
                          zod.null(),
                        ]),
                        weight_percent_max_tolerance: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                          ),
                        expected_over_tolerance_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                          ),
                        expected_under_tolerance_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                          ),
                        warning_level_failure_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                          ),
                        error_level_failure_rate_percent: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                          ),
                      })
                    ),
                    quantiles: zod.array(
                      zod.object({
                        quantile: zod
                          .number()
                          .min(
                            getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin
                          ),
                        weight_percent: zod.number(),
                      })
                    ),
                  })
                ),
                cost: zod.object({
                  cost_per_heat_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerHeatMaterialsMin
                    ),
                  cost_per_heat_electrical_energy: zod.number(),
                  cost_per_tonne_tapped_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin
                    ),
                  cost_per_tonne_tapped_electrical_energy: zod.number(),
                  cost_per_tonne_billets_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                    ),
                  cost_per_tonne_billets_electrical_energy: zod.number(),
                  cost_per_heat: zod.number(),
                  cost_per_tonne_tapped: zod.number(),
                  cost_per_tonne_billets: zod.number(),
                  display_cost_per_tonne_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                    )
                    .describe(
                      "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                    ),
                  display_cost_per_tonne_electrical_energy: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                    )
                    .describe(
                      "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                    ),
                  display_cost_per_tonne: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostDisplayCostPerTonneMin
                    )
                    .describe(
                      "The total cost per tonne to display in the frontend. "
                    ),
                  cost_per_tonne_charged_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin
                    ),
                  cost_per_tonne_charged_electrical_energy: zod.number(),
                  cost_per_tonne_charged: zod.number(),
                }),
                cost_per_target_mass: zod.object({
                  cost_per_heat_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                    ),
                  cost_per_heat_electrical_energy: zod.number(),
                  cost_per_tonne_tapped_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                    ),
                  cost_per_tonne_tapped_electrical_energy: zod.number(),
                  cost_per_tonne_billets_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                    ),
                  cost_per_tonne_billets_electrical_energy: zod.number(),
                  cost_per_heat: zod.number(),
                  cost_per_tonne_tapped: zod.number(),
                  cost_per_tonne_billets: zod.number(),
                  display_cost_per_tonne_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                    )
                    .describe(
                      "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                    ),
                  display_cost_per_tonne_electrical_energy: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                    )
                    .describe(
                      "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                    ),
                  display_cost_per_tonne: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                    )
                    .describe(
                      "The total cost per tonne to display in the frontend. "
                    ),
                  cost_per_tonne_charged_materials: zod
                    .number()
                    .min(
                      getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                    ),
                  cost_per_tonne_charged_electrical_energy: zod.number(),
                  cost_per_tonne_charged: zod.number(),
                }),
                basket_summaries: zod.array(
                  zod.object({
                    chef_group_name: zod.string(),
                    basket_number: zod
                      .int()
                      .gt(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                      ),
                    recipe_mass: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemRecipeMassMin
                      ),
                    volume: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemVolumeMin
                      ),
                    fullness: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemFullnessMin
                      ),
                    min_fill_level: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinFillLevelMin
                      ),
                    max_fill_level: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin
                      ),
                    min_mass: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMinMassMin
                      ),
                    max_mass: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemMaxMassMin
                      ),
                    basket_volume: zod
                      .number()
                      .min(
                        getDeployedPlanResultsResponsePeriodsProductGroupResultsItemMixSummaryOneBasketSummariesItemBasketVolumeMin
                      ),
                  })
                ),
              }),
              zod.null(),
            ]),
          }),
        })
      ),
    })
  ),
  slack_variable_usage: zod.array(
    zod.object({
      details: zod.record(
        zod.string(),
        zod.union([zod.string(), zod.number()])
      ),
      slack_variable: zod.enum([
        "unobtainium_purchased",
        "unobtainium_consumed",
        "material_period_exclusivity_constraint_violated",
        "target_inventory_increases",
        "target_inventory_decreases",
        "soft_material_max_increases",
        "soft_material_min_decreases",
        "soft_material_exclusivity_constraint_violated",
        "mix_use_count_increases",
        "impurity_weight_percent_max_increase",
        "impurity_weight_percent_min_decrease",
      ]),
      usage: zod.number(),
      period: zod.int(),
      cost: zod.number(),
    })
  ),
  summary: zod
    .object({
      period_summary: zod.array(
        zod.object({
          cost_per_heat_materials: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerHeatMaterialsMin
            ),
          cost_per_heat_electrical_energy: zod.number(),
          cost_per_tonne_tapped_materials: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneTappedMaterialsMin
            ),
          cost_per_tonne_tapped_electrical_energy: zod.number(),
          cost_per_tonne_billets_materials: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneBilletsMaterialsMin
            ),
          cost_per_tonne_billets_electrical_energy: zod.number(),
          cost_per_heat: zod.number(),
          cost_per_tonne_tapped: zod.number(),
          cost_per_tonne_billets: zod.number(),
          display_cost_per_tonne_materials: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMaterialsMin
            )
            .describe(
              "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
            ),
          display_cost_per_tonne_electrical_energy: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneElectricalEnergyMin
            )
            .describe(
              "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
            ),
          display_cost_per_tonne: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayCostPerTonneMin
            )
            .describe("The total cost per tonne to display in the frontend. "),
          cost_per_tonne_charged_materials: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemCostPerTonneChargedMaterialsMin
            ),
          cost_per_tonne_charged_electrical_energy: zod.number(),
          cost_per_tonne_charged: zod.number(),
          recipe_mass: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemRecipeMassMin
            ),
          scrap_mass: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemScrapMassMin
            ),
          dri_mass: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemDriMassMin
            ),
          tapped_mass: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemTappedMassMin
            ),
          target_tapped_mass_lower: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemTargetTappedMassLowerMin
            ),
          billet_mass: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemBilletMassMin
            ),
          yield_percent: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemYieldPercentMin
            ),
          yield_percent_billets: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemYieldPercentBilletsMin
            ),
          display_produced_mass: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayProducedMassMin
            )
            .describe(
              "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
            ),
          display_yield_percent: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemDisplayYieldPercentMin
            )
            .describe(
              "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
            ),
          period: zod
            .int()
            .gt(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemPeriodExclusiveMin
            ),
          name: zod.union([zod.string(), zod.null()]),
          is_deployable: zod.boolean(),
          start_timestamp: zod.union([
            zod.iso.datetime({ offset: true }),
            zod.null(),
          ]),
          end_timestamp: zod.union([
            zod.iso.datetime({ offset: true }),
            zod.null(),
          ]),
          num_heats: zod
            .int()
            .gt(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemNumHeatsExclusiveMin
            ),
          total_cost_materials: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodSummaryItemTotalCostMaterialsMin
            ),
          total_cost_electrical_energy: zod.number(),
          total_cost: zod.number(),
        })
      ),
      period_material_summary: zod.array(
        zod.object({
          period: zod
            .int()
            .gt(
              getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemPeriodExclusiveMin
            ),
          material: zod.string(),
          initial_inventory: zod
            .number()
            .describe(
              "The initial inventory at the start of the period, not counting any obtainable acquired during the period. (Can be negative due to unobtainium.)"
            ),
          final_inventory: zod
            .number()
            .describe(
              "The inventory at the end of the period, after the obtainable has been added and consumption subtracted. (Can be negative due to unobtainium)."
            ),
          mass_consumed: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemMassConsumedMin
            )
            .describe("The mass consumed of the material in the period"),
          obtainable_obtained: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainableObtainedMin
            )
            .describe("The mass of material obtained during the period"),
          obtainable_remaining: zod
            .number()
            .describe(
              "The mass of material that could have been obtained in the period but was not. (Can be negative due to unobtainium.)"
            ),
          obtained_price_per_tonne: zod
            .union([
              zod
                .number()
                .min(
                  getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemObtainedPricePerTonneOneMin
                ),
              zod.null(),
            ])
            .describe(
              "The price per unit mass of the material obtained during the period. Null if no material was obtained"
            ),
          cost_per_tonne_material: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemCostPerTonneMaterialMin
            )
            .describe(
              "The material cost per unit mass of the material consumed in the period"
            ),
          cost_per_tonne_electrical_energy: zod
            .number()
            .describe(
              "The electrical energy cost per unit mass of the material consumed in the period. (Can be negative due to negative energy prices)."
            ),
          cost_consumed: zod
            .number()
            .min(
              getDeployedPlanResultsResponseSummaryPeriodMaterialSummaryItemCostConsumedMin
            )
            .describe(
              "The total material cost in the period (not including electrical energy)"
            ),
        })
      ),
    })
    .describe("Summary attached to name-based results."),
  metadata: zod.object({
    base_plan_id: zod.int(),
    parent_plan_id: zod.union([zod.int(), zod.null()]),
    created_by_name: zod.string(),
    created_at: zod.iso.datetime({ offset: true }),
    plan_type: zod.enum(["base", "edited", "fallback"]),
  }),
  start_at: zod.iso.datetime({ offset: true }),
  end_at: zod.iso.datetime({ offset: true }),
  steel_grade_set: zod.object({
    id: zod.int(),
    name: zod
      .string()
      .min(1)
      .max(getDeployedPlanResultsResponseSteelGradeSetNameMax),
    created_at: zod.iso.datetime({ offset: true }),
    created_by_id: zod.string(),
    steel_grades: zod.array(
      zod.object({
        id: zod.int(),
        name: zod.string(),
        chemical_constraints: zod.array(
          zod.object({
            weight_percent_min: zod
              .union([zod.number(), zod.null()])
              .optional(),
            weight_percent_max: zod.number(),
            adjusted_weight_percent_max: zod.number(),
            max_failure_rate: zod.number(),
            coefficients: zod.array(
              zod.object({
                chemical_element: zod.object({
                  id: zod.int(),
                  name: zod.string(),
                  symbol: zod
                    .string()
                    .max(
                      getDeployedPlanResultsResponseSteelGradeSetSteelGradesItemChemicalConstraintsItemCoefficientsItemChemicalElementSymbolMax
                    ),
                  status: zod.enum(["modelled", "visible", "unused"]),
                  ordering: zod.int(),
                }),
                coefficient: zod.number(),
              })
            ),
            name: zod.union([zod.string(), zod.null()]).optional(),
          })
        ),
        fraction_of_heats: zod
          .number()
          .min(
            getDeployedPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMin
          )
          .max(
            getDeployedPlanResultsResponseSteelGradeSetSteelGradesItemFractionOfHeatsMax
          ),
      })
    ),
  }),
  originally_deployed_mix_ids: zod
    .record(zod.string(), zod.int())
    .describe(
      "Mapping from mix IDs in the current plan to their equivalents in the plan originally deployed to the scrapyard"
    ),
  deployed_at: zod.iso.datetime({ offset: true }),
  deployment_type: zod.enum([
    "standard",
    "edited_standard",
    "backup",
    "edited_backup",
    "purchasing_plan",
  ]),
});

/**
 * @summary Get Deployed Plan Metadata
 */
export const GetDeployedPlanMetadataParams = zod.object({
  tenant_name: zod.string(),
});

export const GetDeployedPlanMetadataQueryParams = zod.object({
  deployment_types: zod
    .union([
      zod.array(
        zod.enum([
          "standard",
          "edited_standard",
          "backup",
          "edited_backup",
          "purchasing_plan",
        ])
      ),
      zod.null(),
    ])
    .optional(),
});

export const GetDeployedPlanMetadataResponse = zod.object({
  id: zod.int(),
  plan_id: zod.int(),
  deployed_at: zod.iso.datetime({ offset: true }),
  start_at: zod.iso.datetime({ offset: true }),
  end_at: zod.iso.datetime({ offset: true }),
  user_id: zod.string(),
  deployment_type: zod.enum([
    "standard",
    "edited_standard",
    "backup",
    "edited_backup",
    "purchasing_plan",
  ]),
  deployed_by_name: zod.string(),
});

/**
 * @summary Get Plan Results Excel Endpoint
 */
export const GetPlanResultsExcelParams = zod.object({
  tenant_name: zod.string(),
  plan_id: zod.int(),
  language: zod.enum(["DE", "EN", "ES", "FR", "PL"]),
});

export const GetPlanResultsExcelQueryParams = zod.object({
  period: zod.union([zod.int(), zod.null()]).optional(),
});

export const GetPlanResultsExcelResponse = zod.unknown();

/**
 * @summary Deploy Plan Endpoint
 */
export const DeployPlanParams = zod.object({
  tenant_name: zod.string(),
  plan_id: zod.int(),
});

export const DeployPlanBody = zod.object({
  process: zod.enum([
    "edit_sync_and_sms",
    "sync_and_sms",
    "edit_and_send",
    "message",
    "none",
  ]),
  start_at: zod.iso.datetime({ offset: true }),
  end_at: zod.iso.datetime({ offset: true }),
  language: zod.enum(["DE", "EN", "ES", "FR", "PL"]),
  deployment_type: zod.enum([
    "standard",
    "edited_standard",
    "backup",
    "edited_backup",
    "purchasing_plan",
  ]),
});

export const DeployPlanResponse = zod.void();

/**
 * @summary Create Heat Override Endpoint
 */
export const CreateHeatOverrideParams = zod.object({
  tenant_name: zod.string(),
});

export const createHeatOverrideBodyOneChargeDeltasItemMaterialDeltasMax = 6;

export const CreateHeatOverrideBody = zod.union([
  zod.object({
    stable_heat_ids: zod
      .array(zod.string())
      .describe("Stable IDs of the heats the override claims"),
    reason: zod.string(),
    subreason: zod.union([zod.string(), zod.null()]),
    comment: zod.union([zod.string(), zod.null()]),
    baseline_mix_id: zod
      .int()
      .describe(
        "The floor mix the client showed the user; the server rejects the create when the floor has moved since"
      ),
    mode: zod.literal("delta").meta({ title: "Mode" }),
    charge_deltas: zod
      .array(
        zod.object({
          basket_number: zod.int(),
          material_deltas: zod
            .array(
              zod.object({
                material_name: zod.string(),
                mass_delta_per_heat: zod
                  .number()
                  .describe(
                    "Signed change to the material's mass in the charge of each heat, in tenant mass units"
                  ),
              })
            )
            .min(1)
            .max(createHeatOverrideBodyOneChargeDeltasItemMaterialDeltasMax),
        })
      )
      .min(1),
  }),
  zod.object({
    stable_heat_ids: zod
      .array(zod.string())
      .describe("Stable IDs of the heats the override claims"),
    reason: zod.string(),
    subreason: zod.union([zod.string(), zod.null()]),
    comment: zod.union([zod.string(), zod.null()]),
    baseline_mix_id: zod
      .int()
      .describe(
        "The floor mix the client showed the user; the server rejects the create when the floor has moved since"
      ),
    mode: zod.literal("catalog").meta({ title: "Mode" }),
    catalog: zod.object({
      fixed_mix_set_id: zod.int(),
      mix_id: zod.int(),
    }),
  }),
]);

export const CreateHeatOverrideResponse = zod.object({
  override_id: zod.int(),
});

/**
 * @summary List Completed Heats Endpoint
 */
export const ListCompletedHeatsParams = zod.object({
  tenant_name: zod.string(),
});

export const ListCompletedHeatsQueryParams = zod.object({
  heat_id: zod.int(),
});

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsRecipeMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsScrapMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsDriMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsTappedMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsBilletMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsYieldPercentMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsRecipeMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsScrapMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsDriMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsTappedMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsBilletMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsYieldPercentMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const ListCompletedHeatsResponse = zod.object({
  heats: zod
    .array(
      zod.object({
        heat_id: zod.int(),
        stable_heat_id: zod.string(),
        steel_grade: zod.string(),
        product_group: zod.union([zod.string(), zod.null()]),
        recipe_name: zod.union([zod.string(), zod.null()]),
        recipe: zod.union([
          zod.object({
            name: zod.string(),
            mix: zod.object({
              baskets: zod.array(
                zod.object({
                  basket_number: zod.int(),
                  layers: zod.array(
                    zod.object({
                      material_name: zod.string(),
                      quantity: zod.object({
                        value: zod.number(),
                        unit: zod
                          .enum(["mass", "ratio", "grab"])
                          .describe(
                            "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                          ),
                      }),
                      layer_number: zod.int(),
                      layer_group_id: zod
                        .union([zod.int(), zod.null()])
                        .optional()
                        .describe(
                          "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                        ),
                    })
                  ),
                })
              ),
              furnace: zod.array(
                zod.object({
                  material_name: zod.string(),
                  quantity: zod.object({
                    value: zod.number(),
                    unit: zod
                      .enum(["mass", "ratio", "grab"])
                      .describe(
                        "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                      ),
                  }),
                })
              ),
              thresholds: zod.union([
                zod.array(
                  zod.object({
                    material_name: zod.string(),
                    upper: zod.union([zod.number(), zod.null()]),
                    lower: zod.union([zod.number(), zod.null()]),
                    unit: zod
                      .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                      .describe(
                        "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                      ),
                  })
                ),
                zod.null(),
              ]),
              id: zod.int(),
              basket_totals: zod.array(
                zod.object({
                  material_name: zod.string(),
                  mass: zod.number(),
                })
              ),
              summary: zod.union([
                zod.object({
                  physics: zod.object({
                    recipe_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsRecipeMassMin
                      ),
                    scrap_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsScrapMassMin
                      ),
                    dri_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsDriMassMin
                      ),
                    tapped_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsTappedMassMin
                      ),
                    target_tapped_mass_lower: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsTargetTappedMassLowerMin
                      ),
                    billet_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsBilletMassMin
                      ),
                    yield_percent: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsYieldPercentMin
                      ),
                    yield_percent_billets: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsYieldPercentBilletsMin
                      ),
                    display_produced_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsDisplayProducedMassMin
                      )
                      .describe(
                        "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                      ),
                    display_yield_percent: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOnePhysicsDisplayYieldPercentMin
                      )
                      .describe(
                        "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                      ),
                  }),
                  chemistry: zod.array(
                    zod.object({
                      constraint_name: zod.string(),
                      ordering: zod.int(),
                      weight_percent_loc: zod.number(),
                      weight_percent_scale: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemWeightPercentScaleMin
                        ),
                      steel_grade_risks: zod.array(
                        zod.object({
                          steel_grade_id: zod.int(),
                          weight_percent_min_tolerance: zod.union([
                            zod
                              .number()
                              .min(
                                listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                              ),
                            zod.null(),
                          ]),
                          weight_percent_max_tolerance: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                            ),
                          expected_over_tolerance_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                            ),
                          expected_under_tolerance_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                            ),
                          warning_level_failure_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                            ),
                          error_level_failure_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                            ),
                        })
                      ),
                      quantiles: zod.array(
                        zod.object({
                          quantile: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneChemistryItemQuantilesItemQuantileMin
                            ),
                          weight_percent: zod.number(),
                        })
                      ),
                    })
                  ),
                  cost: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  cost_per_target_mass: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  basket_summaries: zod.array(
                    zod.object({
                      chef_group_name: zod.string(),
                      basket_number: zod
                        .int()
                        .gt(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                        ),
                      recipe_mass: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemRecipeMassMin
                        ),
                      volume: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemVolumeMin
                        ),
                      fullness: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemFullnessMin
                        ),
                      min_fill_level: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMinFillLevelMin
                        ),
                      max_fill_level: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMaxFillLevelMin
                        ),
                      min_mass: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMinMassMin
                        ),
                      max_mass: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemMaxMassMin
                        ),
                      basket_volume: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemRecipeOneMixSummaryOneBasketSummariesItemBasketVolumeMin
                        ),
                    })
                  ),
                }),
                zod.null(),
              ]),
            }),
          }),
          zod.null(),
        ]),
        floor_recipe: zod.union([
          zod.object({
            name: zod.string(),
            mix: zod.object({
              baskets: zod.array(
                zod.object({
                  basket_number: zod.int(),
                  layers: zod.array(
                    zod.object({
                      material_name: zod.string(),
                      quantity: zod.object({
                        value: zod.number(),
                        unit: zod
                          .enum(["mass", "ratio", "grab"])
                          .describe(
                            "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                          ),
                      }),
                      layer_number: zod.int(),
                      layer_group_id: zod
                        .union([zod.int(), zod.null()])
                        .optional()
                        .describe(
                          "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                        ),
                    })
                  ),
                })
              ),
              furnace: zod.array(
                zod.object({
                  material_name: zod.string(),
                  quantity: zod.object({
                    value: zod.number(),
                    unit: zod
                      .enum(["mass", "ratio", "grab"])
                      .describe(
                        "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                      ),
                  }),
                })
              ),
              thresholds: zod.union([
                zod.array(
                  zod.object({
                    material_name: zod.string(),
                    upper: zod.union([zod.number(), zod.null()]),
                    lower: zod.union([zod.number(), zod.null()]),
                    unit: zod
                      .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                      .describe(
                        "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                      ),
                  })
                ),
                zod.null(),
              ]),
              id: zod.int(),
              basket_totals: zod.array(
                zod.object({
                  material_name: zod.string(),
                  mass: zod.number(),
                })
              ),
              summary: zod.union([
                zod.object({
                  physics: zod.object({
                    recipe_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsRecipeMassMin
                      ),
                    scrap_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsScrapMassMin
                      ),
                    dri_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsDriMassMin
                      ),
                    tapped_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsTappedMassMin
                      ),
                    target_tapped_mass_lower: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsTargetTappedMassLowerMin
                      ),
                    billet_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsBilletMassMin
                      ),
                    yield_percent: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsYieldPercentMin
                      ),
                    yield_percent_billets: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsYieldPercentBilletsMin
                      ),
                    display_produced_mass: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsDisplayProducedMassMin
                      )
                      .describe(
                        "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                      ),
                    display_yield_percent: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOnePhysicsDisplayYieldPercentMin
                      )
                      .describe(
                        "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                      ),
                  }),
                  chemistry: zod.array(
                    zod.object({
                      constraint_name: zod.string(),
                      ordering: zod.int(),
                      weight_percent_loc: zod.number(),
                      weight_percent_scale: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemWeightPercentScaleMin
                        ),
                      steel_grade_risks: zod.array(
                        zod.object({
                          steel_grade_id: zod.int(),
                          weight_percent_min_tolerance: zod.union([
                            zod
                              .number()
                              .min(
                                listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                              ),
                            zod.null(),
                          ]),
                          weight_percent_max_tolerance: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                            ),
                          expected_over_tolerance_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                            ),
                          expected_under_tolerance_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                            ),
                          warning_level_failure_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                            ),
                          error_level_failure_rate_percent: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                            ),
                        })
                      ),
                      quantiles: zod.array(
                        zod.object({
                          quantile: zod
                            .number()
                            .min(
                              listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneChemistryItemQuantilesItemQuantileMin
                            ),
                          weight_percent: zod.number(),
                        })
                      ),
                    })
                  ),
                  cost: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  cost_per_target_mass: zod.object({
                    cost_per_heat_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                      ),
                    cost_per_heat_electrical_energy: zod.number(),
                    cost_per_tonne_tapped_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                      ),
                    cost_per_tonne_tapped_electrical_energy: zod.number(),
                    cost_per_tonne_billets_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                      ),
                    cost_per_tonne_billets_electrical_energy: zod.number(),
                    cost_per_heat: zod.number(),
                    cost_per_tonne_tapped: zod.number(),
                    cost_per_tonne_billets: zod.number(),
                    display_cost_per_tonne_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                      )
                      .describe(
                        "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                      ),
                    display_cost_per_tonne_electrical_energy: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                      )
                      .describe(
                        "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                      ),
                    display_cost_per_tonne: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                      )
                      .describe(
                        "The total cost per tonne to display in the frontend. "
                      ),
                    cost_per_tonne_charged_materials: zod
                      .number()
                      .min(
                        listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                      ),
                    cost_per_tonne_charged_electrical_energy: zod.number(),
                    cost_per_tonne_charged: zod.number(),
                  }),
                  basket_summaries: zod.array(
                    zod.object({
                      chef_group_name: zod.string(),
                      basket_number: zod
                        .int()
                        .gt(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                        ),
                      recipe_mass: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemRecipeMassMin
                        ),
                      volume: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemVolumeMin
                        ),
                      fullness: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemFullnessMin
                        ),
                      min_fill_level: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMinFillLevelMin
                        ),
                      max_fill_level: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMaxFillLevelMin
                        ),
                      min_mass: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMinMassMin
                        ),
                      max_mass: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemMaxMassMin
                        ),
                      basket_volume: zod
                        .number()
                        .min(
                          listCompletedHeatsResponseHeatsItemFloorRecipeOneMixSummaryOneBasketSummariesItemBasketVolumeMin
                        ),
                    })
                  ),
                }),
                zod.null(),
              ]),
            }),
          }),
          zod.null(),
        ]),
        override_id: zod.union([zod.int(), zod.null()]),
        override: zod.union([
          zod
            .object({
              reason: zod.union([zod.string(), zod.null()]),
              subreason: zod.union([zod.string(), zod.null()]),
              comment: zod
                .union([zod.string(), zod.null()])
                .describe(
                  "Free-text note recorded when the override was deployed"
                ),
            })
            .describe("Why the supervisor moved a heat off the standing plan."),
          zod.null(),
        ]),
        heat_start_time: zod.union([
          zod.iso.datetime({ offset: true }),
          zod.null(),
        ]),
        status: zod.enum(["loading", "melting", "queued", "completed"]),
      })
    )
    .describe(
      "Completed heats from the searched heat onwards, oldest first; empty when no completed heat has the searched ID"
    ),
});

/**
 * @summary Create Completed Heats Override Endpoint
 */
export const CreateCompletedHeatsOverrideParams = zod.object({
  tenant_name: zod.string(),
});

export const CreateCompletedHeatsOverrideBody = zod.object({
  stable_heat_ids: zod
    .array(zod.string())
    .describe("Stable IDs of the heats the override claims"),
  reason: zod.string(),
  subreason: zod.union([zod.string(), zod.null()]),
  comment: zod.union([zod.string(), zod.null()]),
  baseline_mix_id: zod
    .int()
    .describe(
      "The floor mix the client showed the user; the server rejects the create when the floor has moved since"
    ),
  mode: zod.literal("catalog").meta({ title: "Mode" }),
  catalog: zod.object({
    fixed_mix_set_id: zod.int(),
    mix_id: zod.int(),
  }),
});

export const CreateCompletedHeatsOverrideResponse = zod.object({
  override_id: zod.int(),
});

/**
 * @summary List Heat Override History Endpoint
 */
export const ListHeatOverrideHistoryParams = zod.object({
  tenant_name: zod.string(),
});

export const listHeatOverrideHistoryQueryPageSizeMax = 100;

export const ListHeatOverrideHistoryQueryParams = zod.object({
  page: zod.int().min(1),
  page_size: zod.int().min(1).max(listHeatOverrideHistoryQueryPageSizeMax),
  date: zod.union([zod.iso.date(), zod.null()]).optional(),
  start_date: zod.union([zod.iso.date(), zod.null()]).optional(),
  end_date: zod.union([zod.iso.date(), zod.null()]).optional(),
  cancellation: zod.enum(["exclude", "include"]).optional(),
});

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsRecipeMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsScrapMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsDriMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsTappedMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsBilletMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsYieldPercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsRecipeMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsScrapMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsDriMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsTappedMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsBilletMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsYieldPercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsRecipeMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsScrapMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsDriMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsTappedMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsBilletMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsYieldPercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const listHeatOverrideHistoryResponseItemsItemChargeDeltasOneItemMaterialDeltasMax = 6;

export const ListHeatOverrideHistoryResponse = zod.object({
  items: zod.array(
    zod.object({
      override_id: zod.int(),
      created_at: zod.iso.datetime({ offset: true }),
      first_heat_start_time: zod
        .union([zod.iso.datetime({ offset: true }), zod.null()])
        .describe(
          "When the earliest of the override's heats started; null until one starts"
        ),
      heat_status: zod
        .enum(["started", "not_started", "unrecognised"])
        .describe(
          "Unrecognised when none of the override's heats is in the melt plan"
        ),
      created_by: zod.string(),
      cancelled_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
      cancelled_by: zod.union([zod.string(), zod.null()]),
      reason: zod.union([zod.string(), zod.null()]),
      subreason: zod.union([zod.string(), zod.null()]),
      comment: zod.union([zod.string(), zod.null()]),
      recipe_name: zod.union([zod.string(), zod.null()]),
      scopes: zod.array(
        zod.object({
          stable_heat_id: zod.string(),
          expected_grade: zod.string(),
        })
      ),
      editability: zod.enum([
        "available",
        "unfinished",
        "cancelled",
        "unsupported",
      ]),
      versions: zod.array(
        zod.object({
          revision_id: zod.union([zod.int(), zod.null()]),
          edited_at: zod.iso.datetime({ offset: true }),
          edited_by: zod.string(),
          override_mix: zod.object({
            baskets: zod.array(
              zod.object({
                basket_number: zod.int(),
                layers: zod.array(
                  zod.object({
                    material_name: zod.string(),
                    quantity: zod.object({
                      value: zod.number(),
                      unit: zod
                        .enum(["mass", "ratio", "grab"])
                        .describe(
                          "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                        ),
                    }),
                    layer_number: zod.int(),
                    layer_group_id: zod
                      .union([zod.int(), zod.null()])
                      .optional()
                      .describe(
                        "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                      ),
                  })
                ),
              })
            ),
            furnace: zod.array(
              zod.object({
                material_name: zod.string(),
                quantity: zod.object({
                  value: zod.number(),
                  unit: zod
                    .enum(["mass", "ratio", "grab"])
                    .describe(
                      "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                    ),
                }),
              })
            ),
            thresholds: zod.union([
              zod.array(
                zod.object({
                  material_name: zod.string(),
                  upper: zod.union([zod.number(), zod.null()]),
                  lower: zod.union([zod.number(), zod.null()]),
                  unit: zod
                    .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                    .describe(
                      "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                    ),
                })
              ),
              zod.null(),
            ]),
            id: zod.int(),
            basket_totals: zod.array(
              zod.object({
                material_name: zod.string(),
                mass: zod.number(),
              })
            ),
            summary: zod.union([
              zod.object({
                physics: zod.object({
                  recipe_mass: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsRecipeMassMin
                    ),
                  scrap_mass: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsScrapMassMin
                    ),
                  dri_mass: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsDriMassMin
                    ),
                  tapped_mass: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsTappedMassMin
                    ),
                  target_tapped_mass_lower: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin
                    ),
                  billet_mass: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsBilletMassMin
                    ),
                  yield_percent: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsYieldPercentMin
                    ),
                  yield_percent_billets: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsYieldPercentBilletsMin
                    ),
                  display_produced_mass: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsDisplayProducedMassMin
                    )
                    .describe(
                      "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                    ),
                  display_yield_percent: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOnePhysicsDisplayYieldPercentMin
                    )
                    .describe(
                      "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                    ),
                }),
                chemistry: zod.array(
                  zod.object({
                    constraint_name: zod.string(),
                    ordering: zod.int(),
                    weight_percent_loc: zod.number(),
                    weight_percent_scale: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemWeightPercentScaleMin
                      ),
                    steel_grade_risks: zod.array(
                      zod.object({
                        steel_grade_id: zod.int(),
                        weight_percent_min_tolerance: zod.union([
                          zod
                            .number()
                            .min(
                              listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                            ),
                          zod.null(),
                        ]),
                        weight_percent_max_tolerance: zod
                          .number()
                          .min(
                            listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                          ),
                        expected_over_tolerance_rate_percent: zod
                          .number()
                          .min(
                            listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                          ),
                        expected_under_tolerance_rate_percent: zod
                          .number()
                          .min(
                            listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                          ),
                        warning_level_failure_rate_percent: zod
                          .number()
                          .min(
                            listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                          ),
                        error_level_failure_rate_percent: zod
                          .number()
                          .min(
                            listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                          ),
                      })
                    ),
                    quantiles: zod.array(
                      zod.object({
                        quantile: zod
                          .number()
                          .min(
                            listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin
                          ),
                        weight_percent: zod.number(),
                      })
                    ),
                  })
                ),
                cost: zod.object({
                  cost_per_heat_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerHeatMaterialsMin
                    ),
                  cost_per_heat_electrical_energy: zod.number(),
                  cost_per_tonne_tapped_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin
                    ),
                  cost_per_tonne_tapped_electrical_energy: zod.number(),
                  cost_per_tonne_billets_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                    ),
                  cost_per_tonne_billets_electrical_energy: zod.number(),
                  cost_per_heat: zod.number(),
                  cost_per_tonne_tapped: zod.number(),
                  cost_per_tonne_billets: zod.number(),
                  display_cost_per_tonne_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                    )
                    .describe(
                      "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                    ),
                  display_cost_per_tonne_electrical_energy: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                    )
                    .describe(
                      "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                    ),
                  display_cost_per_tonne: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMin
                    )
                    .describe(
                      "The total cost per tonne to display in the frontend. "
                    ),
                  cost_per_tonne_charged_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin
                    ),
                  cost_per_tonne_charged_electrical_energy: zod.number(),
                  cost_per_tonne_charged: zod.number(),
                }),
                cost_per_target_mass: zod.object({
                  cost_per_heat_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                    ),
                  cost_per_heat_electrical_energy: zod.number(),
                  cost_per_tonne_tapped_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                    ),
                  cost_per_tonne_tapped_electrical_energy: zod.number(),
                  cost_per_tonne_billets_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                    ),
                  cost_per_tonne_billets_electrical_energy: zod.number(),
                  cost_per_heat: zod.number(),
                  cost_per_tonne_tapped: zod.number(),
                  cost_per_tonne_billets: zod.number(),
                  display_cost_per_tonne_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                    )
                    .describe(
                      "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                    ),
                  display_cost_per_tonne_electrical_energy: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                    )
                    .describe(
                      "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                    ),
                  display_cost_per_tonne: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                    )
                    .describe(
                      "The total cost per tonne to display in the frontend. "
                    ),
                  cost_per_tonne_charged_materials: zod
                    .number()
                    .min(
                      listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                    ),
                  cost_per_tonne_charged_electrical_energy: zod.number(),
                  cost_per_tonne_charged: zod.number(),
                }),
                basket_summaries: zod.array(
                  zod.object({
                    chef_group_name: zod.string(),
                    basket_number: zod
                      .int()
                      .gt(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                      ),
                    recipe_mass: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemRecipeMassMin
                      ),
                    volume: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemVolumeMin
                      ),
                    fullness: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemFullnessMin
                      ),
                    min_fill_level: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin
                      ),
                    max_fill_level: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin
                      ),
                    min_mass: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMinMassMin
                      ),
                    max_mass: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxMassMin
                      ),
                    basket_volume: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin
                      ),
                  })
                ),
              }),
              zod.null(),
            ]),
          }),
          recipe_name: zod.union([zod.string(), zod.null()]),
          reason: zod.union([zod.string(), zod.null()]),
          subreason: zod.union([zod.string(), zod.null()]),
          comment: zod.union([zod.string(), zod.null()]),
        })
      ),
      replaced_mix: zod.object({
        baskets: zod.array(
          zod.object({
            basket_number: zod.int(),
            layers: zod.array(
              zod.object({
                material_name: zod.string(),
                quantity: zod.object({
                  value: zod.number(),
                  unit: zod
                    .enum(["mass", "ratio", "grab"])
                    .describe(
                      "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                    ),
                }),
                layer_number: zod.int(),
                layer_group_id: zod
                  .union([zod.int(), zod.null()])
                  .optional()
                  .describe(
                    "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                  ),
              })
            ),
          })
        ),
        furnace: zod.array(
          zod.object({
            material_name: zod.string(),
            quantity: zod.object({
              value: zod.number(),
              unit: zod
                .enum(["mass", "ratio", "grab"])
                .describe(
                  "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                ),
            }),
          })
        ),
        thresholds: zod.union([
          zod.array(
            zod.object({
              material_name: zod.string(),
              upper: zod.union([zod.number(), zod.null()]),
              lower: zod.union([zod.number(), zod.null()]),
              unit: zod
                .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                .describe(
                  "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                ),
            })
          ),
          zod.null(),
        ]),
        id: zod.int(),
        basket_totals: zod.array(
          zod.object({
            material_name: zod.string(),
            mass: zod.number(),
          })
        ),
        summary: zod.union([
          zod.object({
            physics: zod.object({
              recipe_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsRecipeMassMin
                ),
              scrap_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsScrapMassMin
                ),
              dri_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsDriMassMin
                ),
              tapped_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsTappedMassMin
                ),
              target_tapped_mass_lower: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsTargetTappedMassLowerMin
                ),
              billet_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsBilletMassMin
                ),
              yield_percent: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsYieldPercentMin
                ),
              yield_percent_billets: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsYieldPercentBilletsMin
                ),
              display_produced_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsDisplayProducedMassMin
                )
                .describe(
                  "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                ),
              display_yield_percent: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOnePhysicsDisplayYieldPercentMin
                )
                .describe(
                  "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                ),
            }),
            chemistry: zod.array(
              zod.object({
                constraint_name: zod.string(),
                ordering: zod.int(),
                weight_percent_loc: zod.number(),
                weight_percent_scale: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemWeightPercentScaleMin
                  ),
                steel_grade_risks: zod.array(
                  zod.object({
                    steel_grade_id: zod.int(),
                    weight_percent_min_tolerance: zod.union([
                      zod
                        .number()
                        .min(
                          listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                        ),
                      zod.null(),
                    ]),
                    weight_percent_max_tolerance: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                      ),
                    expected_over_tolerance_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                      ),
                    expected_under_tolerance_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                      ),
                    warning_level_failure_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                      ),
                    error_level_failure_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                      ),
                  })
                ),
                quantiles: zod.array(
                  zod.object({
                    quantile: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneChemistryItemQuantilesItemQuantileMin
                      ),
                    weight_percent: zod.number(),
                  })
                ),
              })
            ),
            cost: zod.object({
              cost_per_heat_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerHeatMaterialsMin
                ),
              cost_per_heat_electrical_energy: zod.number(),
              cost_per_tonne_tapped_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerTonneTappedMaterialsMin
                ),
              cost_per_tonne_tapped_electrical_energy: zod.number(),
              cost_per_tonne_billets_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                ),
              cost_per_tonne_billets_electrical_energy: zod.number(),
              cost_per_heat: zod.number(),
              cost_per_tonne_tapped: zod.number(),
              cost_per_tonne_billets: zod.number(),
              display_cost_per_tonne_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                )
                .describe(
                  "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                ),
              display_cost_per_tonne_electrical_energy: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                )
                .describe(
                  "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                ),
              display_cost_per_tonne: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostDisplayCostPerTonneMin
                )
                .describe(
                  "The total cost per tonne to display in the frontend. "
                ),
              cost_per_tonne_charged_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostCostPerTonneChargedMaterialsMin
                ),
              cost_per_tonne_charged_electrical_energy: zod.number(),
              cost_per_tonne_charged: zod.number(),
            }),
            cost_per_target_mass: zod.object({
              cost_per_heat_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                ),
              cost_per_heat_electrical_energy: zod.number(),
              cost_per_tonne_tapped_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                ),
              cost_per_tonne_tapped_electrical_energy: zod.number(),
              cost_per_tonne_billets_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                ),
              cost_per_tonne_billets_electrical_energy: zod.number(),
              cost_per_heat: zod.number(),
              cost_per_tonne_tapped: zod.number(),
              cost_per_tonne_billets: zod.number(),
              display_cost_per_tonne_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                )
                .describe(
                  "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                ),
              display_cost_per_tonne_electrical_energy: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                )
                .describe(
                  "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                ),
              display_cost_per_tonne: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                )
                .describe(
                  "The total cost per tonne to display in the frontend. "
                ),
              cost_per_tonne_charged_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                ),
              cost_per_tonne_charged_electrical_energy: zod.number(),
              cost_per_tonne_charged: zod.number(),
            }),
            basket_summaries: zod.array(
              zod.object({
                chef_group_name: zod.string(),
                basket_number: zod
                  .int()
                  .gt(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                  ),
                recipe_mass: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemRecipeMassMin
                  ),
                volume: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemVolumeMin
                  ),
                fullness: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemFullnessMin
                  ),
                min_fill_level: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMinFillLevelMin
                  ),
                max_fill_level: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMaxFillLevelMin
                  ),
                min_mass: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMinMassMin
                  ),
                max_mass: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemMaxMassMin
                  ),
                basket_volume: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemReplacedMixSummaryOneBasketSummariesItemBasketVolumeMin
                  ),
              })
            ),
          }),
          zod.null(),
        ]),
      }),
      override_mix: zod.object({
        baskets: zod.array(
          zod.object({
            basket_number: zod.int(),
            layers: zod.array(
              zod.object({
                material_name: zod.string(),
                quantity: zod.object({
                  value: zod.number(),
                  unit: zod
                    .enum(["mass", "ratio", "grab"])
                    .describe(
                      "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                    ),
                }),
                layer_number: zod.int(),
                layer_group_id: zod
                  .union([zod.int(), zod.null()])
                  .optional()
                  .describe(
                    "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                  ),
              })
            ),
          })
        ),
        furnace: zod.array(
          zod.object({
            material_name: zod.string(),
            quantity: zod.object({
              value: zod.number(),
              unit: zod
                .enum(["mass", "ratio", "grab"])
                .describe(
                  "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                ),
            }),
          })
        ),
        thresholds: zod.union([
          zod.array(
            zod.object({
              material_name: zod.string(),
              upper: zod.union([zod.number(), zod.null()]),
              lower: zod.union([zod.number(), zod.null()]),
              unit: zod
                .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                .describe(
                  "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                ),
            })
          ),
          zod.null(),
        ]),
        id: zod.int(),
        basket_totals: zod.array(
          zod.object({
            material_name: zod.string(),
            mass: zod.number(),
          })
        ),
        summary: zod.union([
          zod.object({
            physics: zod.object({
              recipe_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsRecipeMassMin
                ),
              scrap_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsScrapMassMin
                ),
              dri_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsDriMassMin
                ),
              tapped_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsTappedMassMin
                ),
              target_tapped_mass_lower: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin
                ),
              billet_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsBilletMassMin
                ),
              yield_percent: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsYieldPercentMin
                ),
              yield_percent_billets: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsYieldPercentBilletsMin
                ),
              display_produced_mass: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsDisplayProducedMassMin
                )
                .describe(
                  "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                ),
              display_yield_percent: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOnePhysicsDisplayYieldPercentMin
                )
                .describe(
                  "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                ),
            }),
            chemistry: zod.array(
              zod.object({
                constraint_name: zod.string(),
                ordering: zod.int(),
                weight_percent_loc: zod.number(),
                weight_percent_scale: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemWeightPercentScaleMin
                  ),
                steel_grade_risks: zod.array(
                  zod.object({
                    steel_grade_id: zod.int(),
                    weight_percent_min_tolerance: zod.union([
                      zod
                        .number()
                        .min(
                          listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                        ),
                      zod.null(),
                    ]),
                    weight_percent_max_tolerance: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                      ),
                    expected_over_tolerance_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                      ),
                    expected_under_tolerance_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                      ),
                    warning_level_failure_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                      ),
                    error_level_failure_rate_percent: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                      ),
                  })
                ),
                quantiles: zod.array(
                  zod.object({
                    quantile: zod
                      .number()
                      .min(
                        listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin
                      ),
                    weight_percent: zod.number(),
                  })
                ),
              })
            ),
            cost: zod.object({
              cost_per_heat_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerHeatMaterialsMin
                ),
              cost_per_heat_electrical_energy: zod.number(),
              cost_per_tonne_tapped_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin
                ),
              cost_per_tonne_tapped_electrical_energy: zod.number(),
              cost_per_tonne_billets_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                ),
              cost_per_tonne_billets_electrical_energy: zod.number(),
              cost_per_heat: zod.number(),
              cost_per_tonne_tapped: zod.number(),
              cost_per_tonne_billets: zod.number(),
              display_cost_per_tonne_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                )
                .describe(
                  "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                ),
              display_cost_per_tonne_electrical_energy: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                )
                .describe(
                  "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                ),
              display_cost_per_tonne: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostDisplayCostPerTonneMin
                )
                .describe(
                  "The total cost per tonne to display in the frontend. "
                ),
              cost_per_tonne_charged_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin
                ),
              cost_per_tonne_charged_electrical_energy: zod.number(),
              cost_per_tonne_charged: zod.number(),
            }),
            cost_per_target_mass: zod.object({
              cost_per_heat_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                ),
              cost_per_heat_electrical_energy: zod.number(),
              cost_per_tonne_tapped_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                ),
              cost_per_tonne_tapped_electrical_energy: zod.number(),
              cost_per_tonne_billets_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                ),
              cost_per_tonne_billets_electrical_energy: zod.number(),
              cost_per_heat: zod.number(),
              cost_per_tonne_tapped: zod.number(),
              cost_per_tonne_billets: zod.number(),
              display_cost_per_tonne_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                )
                .describe(
                  "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                ),
              display_cost_per_tonne_electrical_energy: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                )
                .describe(
                  "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                ),
              display_cost_per_tonne: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                )
                .describe(
                  "The total cost per tonne to display in the frontend. "
                ),
              cost_per_tonne_charged_materials: zod
                .number()
                .min(
                  listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                ),
              cost_per_tonne_charged_electrical_energy: zod.number(),
              cost_per_tonne_charged: zod.number(),
            }),
            basket_summaries: zod.array(
              zod.object({
                chef_group_name: zod.string(),
                basket_number: zod
                  .int()
                  .gt(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                  ),
                recipe_mass: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemRecipeMassMin
                  ),
                volume: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemVolumeMin
                  ),
                fullness: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemFullnessMin
                  ),
                min_fill_level: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin
                  ),
                max_fill_level: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin
                  ),
                min_mass: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMinMassMin
                  ),
                max_mass: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemMaxMassMin
                  ),
                basket_volume: zod
                  .number()
                  .min(
                    listHeatOverrideHistoryResponseItemsItemOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin
                  ),
              })
            ),
          }),
          zod.null(),
        ]),
      }),
      charge_deltas: zod
        .union([
          zod.array(
            zod.object({
              basket_number: zod.int(),
              material_deltas: zod
                .array(
                  zod.object({
                    material_name: zod.string(),
                    mass_delta_per_heat: zod
                      .number()
                      .describe(
                        "Signed change to the material's mass in the charge of each heat, in tenant mass units"
                      ),
                  })
                )
                .min(1)
                .max(
                  listHeatOverrideHistoryResponseItemsItemChargeDeltasOneItemMaterialDeltasMax
                ),
            })
          ),
          zod.null(),
        ])
        .describe(
          "Material changes from the replaced mix, per charge; null unless the tenant enters overrides as deltas"
        ),
    })
  ),
  total: zod.int(),
});

/**
 * @summary Edit Heat Override History Endpoint
 */
export const EditHeatOverrideHistoryParams = zod.object({
  tenant_name: zod.string(),
  override_id: zod.int(),
});

export const EditHeatOverrideHistoryBody = zod.object({
  expected_revision_id: zod.union([zod.int(), zod.null()]),
  catalog: zod.union([
    zod.object({
      fixed_mix_set_id: zod.int(),
      mix_id: zod.int(),
    }),
    zod.null(),
  ]),
  reason: zod.union([zod.string(), zod.null()]),
  subreason: zod.union([zod.string(), zod.null()]),
  comment: zod.union([zod.string(), zod.null()]),
});

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsRecipeMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsScrapMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsDriMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsTappedMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsBilletMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsYieldPercentMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsRecipeMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsScrapMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsDriMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsTappedMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsBilletMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsYieldPercentMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsRecipeMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsScrapMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsDriMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsTappedMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsBilletMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsYieldPercentMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const editHeatOverrideHistoryResponseChargeDeltasOneItemMaterialDeltasMax = 6;

export const EditHeatOverrideHistoryResponse = zod.object({
  override_id: zod.int(),
  created_at: zod.iso.datetime({ offset: true }),
  first_heat_start_time: zod
    .union([zod.iso.datetime({ offset: true }), zod.null()])
    .describe(
      "When the earliest of the override's heats started; null until one starts"
    ),
  heat_status: zod
    .enum(["started", "not_started", "unrecognised"])
    .describe(
      "Unrecognised when none of the override's heats is in the melt plan"
    ),
  created_by: zod.string(),
  cancelled_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
  cancelled_by: zod.union([zod.string(), zod.null()]),
  reason: zod.union([zod.string(), zod.null()]),
  subreason: zod.union([zod.string(), zod.null()]),
  comment: zod.union([zod.string(), zod.null()]),
  recipe_name: zod.union([zod.string(), zod.null()]),
  scopes: zod.array(
    zod.object({
      stable_heat_id: zod.string(),
      expected_grade: zod.string(),
    })
  ),
  editability: zod.enum([
    "available",
    "unfinished",
    "cancelled",
    "unsupported",
  ]),
  versions: zod.array(
    zod.object({
      revision_id: zod.union([zod.int(), zod.null()]),
      edited_at: zod.iso.datetime({ offset: true }),
      edited_by: zod.string(),
      override_mix: zod.object({
        baskets: zod.array(
          zod.object({
            basket_number: zod.int(),
            layers: zod.array(
              zod.object({
                material_name: zod.string(),
                quantity: zod.object({
                  value: zod.number(),
                  unit: zod
                    .enum(["mass", "ratio", "grab"])
                    .describe(
                      "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                    ),
                }),
                layer_number: zod.int(),
                layer_group_id: zod
                  .union([zod.int(), zod.null()])
                  .optional()
                  .describe(
                    "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                  ),
              })
            ),
          })
        ),
        furnace: zod.array(
          zod.object({
            material_name: zod.string(),
            quantity: zod.object({
              value: zod.number(),
              unit: zod
                .enum(["mass", "ratio", "grab"])
                .describe(
                  "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                ),
            }),
          })
        ),
        thresholds: zod.union([
          zod.array(
            zod.object({
              material_name: zod.string(),
              upper: zod.union([zod.number(), zod.null()]),
              lower: zod.union([zod.number(), zod.null()]),
              unit: zod
                .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                .describe(
                  "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                ),
            })
          ),
          zod.null(),
        ]),
        id: zod.int(),
        basket_totals: zod.array(
          zod.object({
            material_name: zod.string(),
            mass: zod.number(),
          })
        ),
        summary: zod.union([
          zod.object({
            physics: zod.object({
              recipe_mass: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsRecipeMassMin
                ),
              scrap_mass: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsScrapMassMin
                ),
              dri_mass: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsDriMassMin
                ),
              tapped_mass: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsTappedMassMin
                ),
              target_tapped_mass_lower: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin
                ),
              billet_mass: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsBilletMassMin
                ),
              yield_percent: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsYieldPercentMin
                ),
              yield_percent_billets: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsYieldPercentBilletsMin
                ),
              display_produced_mass: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsDisplayProducedMassMin
                )
                .describe(
                  "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                ),
              display_yield_percent: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOnePhysicsDisplayYieldPercentMin
                )
                .describe(
                  "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                ),
            }),
            chemistry: zod.array(
              zod.object({
                constraint_name: zod.string(),
                ordering: zod.int(),
                weight_percent_loc: zod.number(),
                weight_percent_scale: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemWeightPercentScaleMin
                  ),
                steel_grade_risks: zod.array(
                  zod.object({
                    steel_grade_id: zod.int(),
                    weight_percent_min_tolerance: zod.union([
                      zod
                        .number()
                        .min(
                          editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                        ),
                      zod.null(),
                    ]),
                    weight_percent_max_tolerance: zod
                      .number()
                      .min(
                        editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                      ),
                    expected_over_tolerance_rate_percent: zod
                      .number()
                      .min(
                        editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                      ),
                    expected_under_tolerance_rate_percent: zod
                      .number()
                      .min(
                        editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                      ),
                    warning_level_failure_rate_percent: zod
                      .number()
                      .min(
                        editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                      ),
                    error_level_failure_rate_percent: zod
                      .number()
                      .min(
                        editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                      ),
                  })
                ),
                quantiles: zod.array(
                  zod.object({
                    quantile: zod
                      .number()
                      .min(
                        editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin
                      ),
                    weight_percent: zod.number(),
                  })
                ),
              })
            ),
            cost: zod.object({
              cost_per_heat_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerHeatMaterialsMin
                ),
              cost_per_heat_electrical_energy: zod.number(),
              cost_per_tonne_tapped_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin
                ),
              cost_per_tonne_tapped_electrical_energy: zod.number(),
              cost_per_tonne_billets_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                ),
              cost_per_tonne_billets_electrical_energy: zod.number(),
              cost_per_heat: zod.number(),
              cost_per_tonne_tapped: zod.number(),
              cost_per_tonne_billets: zod.number(),
              display_cost_per_tonne_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                )
                .describe(
                  "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                ),
              display_cost_per_tonne_electrical_energy: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                )
                .describe(
                  "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                ),
              display_cost_per_tonne: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostDisplayCostPerTonneMin
                )
                .describe(
                  "The total cost per tonne to display in the frontend. "
                ),
              cost_per_tonne_charged_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin
                ),
              cost_per_tonne_charged_electrical_energy: zod.number(),
              cost_per_tonne_charged: zod.number(),
            }),
            cost_per_target_mass: zod.object({
              cost_per_heat_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                ),
              cost_per_heat_electrical_energy: zod.number(),
              cost_per_tonne_tapped_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                ),
              cost_per_tonne_tapped_electrical_energy: zod.number(),
              cost_per_tonne_billets_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                ),
              cost_per_tonne_billets_electrical_energy: zod.number(),
              cost_per_heat: zod.number(),
              cost_per_tonne_tapped: zod.number(),
              cost_per_tonne_billets: zod.number(),
              display_cost_per_tonne_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                )
                .describe(
                  "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                ),
              display_cost_per_tonne_electrical_energy: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                )
                .describe(
                  "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                ),
              display_cost_per_tonne: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                )
                .describe(
                  "The total cost per tonne to display in the frontend. "
                ),
              cost_per_tonne_charged_materials: zod
                .number()
                .min(
                  editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                ),
              cost_per_tonne_charged_electrical_energy: zod.number(),
              cost_per_tonne_charged: zod.number(),
            }),
            basket_summaries: zod.array(
              zod.object({
                chef_group_name: zod.string(),
                basket_number: zod
                  .int()
                  .gt(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                  ),
                recipe_mass: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemRecipeMassMin
                  ),
                volume: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemVolumeMin
                  ),
                fullness: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemFullnessMin
                  ),
                min_fill_level: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin
                  ),
                max_fill_level: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin
                  ),
                min_mass: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMinMassMin
                  ),
                max_mass: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemMaxMassMin
                  ),
                basket_volume: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseVersionsItemOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin
                  ),
              })
            ),
          }),
          zod.null(),
        ]),
      }),
      recipe_name: zod.union([zod.string(), zod.null()]),
      reason: zod.union([zod.string(), zod.null()]),
      subreason: zod.union([zod.string(), zod.null()]),
      comment: zod.union([zod.string(), zod.null()]),
    })
  ),
  replaced_mix: zod.object({
    baskets: zod.array(
      zod.object({
        basket_number: zod.int(),
        layers: zod.array(
          zod.object({
            material_name: zod.string(),
            quantity: zod.object({
              value: zod.number(),
              unit: zod
                .enum(["mass", "ratio", "grab"])
                .describe(
                  "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                ),
            }),
            layer_number: zod.int(),
            layer_group_id: zod
              .union([zod.int(), zod.null()])
              .optional()
              .describe(
                "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
              ),
          })
        ),
      })
    ),
    furnace: zod.array(
      zod.object({
        material_name: zod.string(),
        quantity: zod.object({
          value: zod.number(),
          unit: zod
            .enum(["mass", "ratio", "grab"])
            .describe(
              "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
            ),
        }),
      })
    ),
    thresholds: zod.union([
      zod.array(
        zod.object({
          material_name: zod.string(),
          upper: zod.union([zod.number(), zod.null()]),
          lower: zod.union([zod.number(), zod.null()]),
          unit: zod
            .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
            .describe(
              "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
            ),
        })
      ),
      zod.null(),
    ]),
    id: zod.int(),
    basket_totals: zod.array(
      zod.object({
        material_name: zod.string(),
        mass: zod.number(),
      })
    ),
    summary: zod.union([
      zod.object({
        physics: zod.object({
          recipe_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsRecipeMassMin
            ),
          scrap_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsScrapMassMin
            ),
          dri_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsDriMassMin
            ),
          tapped_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsTappedMassMin
            ),
          target_tapped_mass_lower: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsTargetTappedMassLowerMin
            ),
          billet_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsBilletMassMin
            ),
          yield_percent: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsYieldPercentMin
            ),
          yield_percent_billets: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsYieldPercentBilletsMin
            ),
          display_produced_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsDisplayProducedMassMin
            )
            .describe(
              "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
            ),
          display_yield_percent: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOnePhysicsDisplayYieldPercentMin
            )
            .describe(
              "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
            ),
        }),
        chemistry: zod.array(
          zod.object({
            constraint_name: zod.string(),
            ordering: zod.int(),
            weight_percent_loc: zod.number(),
            weight_percent_scale: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemWeightPercentScaleMin
              ),
            steel_grade_risks: zod.array(
              zod.object({
                steel_grade_id: zod.int(),
                weight_percent_min_tolerance: zod.union([
                  zod
                    .number()
                    .min(
                      editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                    ),
                  zod.null(),
                ]),
                weight_percent_max_tolerance: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                  ),
                expected_over_tolerance_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                  ),
                expected_under_tolerance_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                  ),
                warning_level_failure_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                  ),
                error_level_failure_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                  ),
              })
            ),
            quantiles: zod.array(
              zod.object({
                quantile: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseReplacedMixSummaryOneChemistryItemQuantilesItemQuantileMin
                  ),
                weight_percent: zod.number(),
              })
            ),
          })
        ),
        cost: zod.object({
          cost_per_heat_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerHeatMaterialsMin
            ),
          cost_per_heat_electrical_energy: zod.number(),
          cost_per_tonne_tapped_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerTonneTappedMaterialsMin
            ),
          cost_per_tonne_tapped_electrical_energy: zod.number(),
          cost_per_tonne_billets_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerTonneBilletsMaterialsMin
            ),
          cost_per_tonne_billets_electrical_energy: zod.number(),
          cost_per_heat: zod.number(),
          cost_per_tonne_tapped: zod.number(),
          cost_per_tonne_billets: zod.number(),
          display_cost_per_tonne_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostDisplayCostPerTonneMaterialsMin
            )
            .describe(
              "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
            ),
          display_cost_per_tonne_electrical_energy: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
            )
            .describe(
              "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
            ),
          display_cost_per_tonne: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostDisplayCostPerTonneMin
            )
            .describe("The total cost per tonne to display in the frontend. "),
          cost_per_tonne_charged_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostCostPerTonneChargedMaterialsMin
            ),
          cost_per_tonne_charged_electrical_energy: zod.number(),
          cost_per_tonne_charged: zod.number(),
        }),
        cost_per_target_mass: zod.object({
          cost_per_heat_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
            ),
          cost_per_heat_electrical_energy: zod.number(),
          cost_per_tonne_tapped_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
            ),
          cost_per_tonne_tapped_electrical_energy: zod.number(),
          cost_per_tonne_billets_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
            ),
          cost_per_tonne_billets_electrical_energy: zod.number(),
          cost_per_heat: zod.number(),
          cost_per_tonne_tapped: zod.number(),
          cost_per_tonne_billets: zod.number(),
          display_cost_per_tonne_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
            )
            .describe(
              "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
            ),
          display_cost_per_tonne_electrical_energy: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
            )
            .describe(
              "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
            ),
          display_cost_per_tonne: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
            )
            .describe("The total cost per tonne to display in the frontend. "),
          cost_per_tonne_charged_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseReplacedMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
            ),
          cost_per_tonne_charged_electrical_energy: zod.number(),
          cost_per_tonne_charged: zod.number(),
        }),
        basket_summaries: zod.array(
          zod.object({
            chef_group_name: zod.string(),
            basket_number: zod
              .int()
              .gt(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
              ),
            recipe_mass: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemRecipeMassMin
              ),
            volume: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemVolumeMin
              ),
            fullness: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemFullnessMin
              ),
            min_fill_level: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMinFillLevelMin
              ),
            max_fill_level: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMaxFillLevelMin
              ),
            min_mass: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMinMassMin
              ),
            max_mass: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemMaxMassMin
              ),
            basket_volume: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseReplacedMixSummaryOneBasketSummariesItemBasketVolumeMin
              ),
          })
        ),
      }),
      zod.null(),
    ]),
  }),
  override_mix: zod.object({
    baskets: zod.array(
      zod.object({
        basket_number: zod.int(),
        layers: zod.array(
          zod.object({
            material_name: zod.string(),
            quantity: zod.object({
              value: zod.number(),
              unit: zod
                .enum(["mass", "ratio", "grab"])
                .describe(
                  "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                ),
            }),
            layer_number: zod.int(),
            layer_group_id: zod
              .union([zod.int(), zod.null()])
              .optional()
              .describe(
                "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
              ),
          })
        ),
      })
    ),
    furnace: zod.array(
      zod.object({
        material_name: zod.string(),
        quantity: zod.object({
          value: zod.number(),
          unit: zod
            .enum(["mass", "ratio", "grab"])
            .describe(
              "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
            ),
        }),
      })
    ),
    thresholds: zod.union([
      zod.array(
        zod.object({
          material_name: zod.string(),
          upper: zod.union([zod.number(), zod.null()]),
          lower: zod.union([zod.number(), zod.null()]),
          unit: zod
            .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
            .describe(
              "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
            ),
        })
      ),
      zod.null(),
    ]),
    id: zod.int(),
    basket_totals: zod.array(
      zod.object({
        material_name: zod.string(),
        mass: zod.number(),
      })
    ),
    summary: zod.union([
      zod.object({
        physics: zod.object({
          recipe_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsRecipeMassMin
            ),
          scrap_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsScrapMassMin
            ),
          dri_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsDriMassMin
            ),
          tapped_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsTappedMassMin
            ),
          target_tapped_mass_lower: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsTargetTappedMassLowerMin
            ),
          billet_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsBilletMassMin
            ),
          yield_percent: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsYieldPercentMin
            ),
          yield_percent_billets: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsYieldPercentBilletsMin
            ),
          display_produced_mass: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsDisplayProducedMassMin
            )
            .describe(
              "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
            ),
          display_yield_percent: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOnePhysicsDisplayYieldPercentMin
            )
            .describe(
              "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
            ),
        }),
        chemistry: zod.array(
          zod.object({
            constraint_name: zod.string(),
            ordering: zod.int(),
            weight_percent_loc: zod.number(),
            weight_percent_scale: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemWeightPercentScaleMin
              ),
            steel_grade_risks: zod.array(
              zod.object({
                steel_grade_id: zod.int(),
                weight_percent_min_tolerance: zod.union([
                  zod
                    .number()
                    .min(
                      editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                    ),
                  zod.null(),
                ]),
                weight_percent_max_tolerance: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                  ),
                expected_over_tolerance_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                  ),
                expected_under_tolerance_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                  ),
                warning_level_failure_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                  ),
                error_level_failure_rate_percent: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                  ),
              })
            ),
            quantiles: zod.array(
              zod.object({
                quantile: zod
                  .number()
                  .min(
                    editHeatOverrideHistoryResponseOverrideMixSummaryOneChemistryItemQuantilesItemQuantileMin
                  ),
                weight_percent: zod.number(),
              })
            ),
          })
        ),
        cost: zod.object({
          cost_per_heat_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerHeatMaterialsMin
            ),
          cost_per_heat_electrical_energy: zod.number(),
          cost_per_tonne_tapped_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerTonneTappedMaterialsMin
            ),
          cost_per_tonne_tapped_electrical_energy: zod.number(),
          cost_per_tonne_billets_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerTonneBilletsMaterialsMin
            ),
          cost_per_tonne_billets_electrical_energy: zod.number(),
          cost_per_heat: zod.number(),
          cost_per_tonne_tapped: zod.number(),
          cost_per_tonne_billets: zod.number(),
          display_cost_per_tonne_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostDisplayCostPerTonneMaterialsMin
            )
            .describe(
              "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
            ),
          display_cost_per_tonne_electrical_energy: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
            )
            .describe(
              "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
            ),
          display_cost_per_tonne: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostDisplayCostPerTonneMin
            )
            .describe("The total cost per tonne to display in the frontend. "),
          cost_per_tonne_charged_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostCostPerTonneChargedMaterialsMin
            ),
          cost_per_tonne_charged_electrical_energy: zod.number(),
          cost_per_tonne_charged: zod.number(),
        }),
        cost_per_target_mass: zod.object({
          cost_per_heat_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
            ),
          cost_per_heat_electrical_energy: zod.number(),
          cost_per_tonne_tapped_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
            ),
          cost_per_tonne_tapped_electrical_energy: zod.number(),
          cost_per_tonne_billets_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
            ),
          cost_per_tonne_billets_electrical_energy: zod.number(),
          cost_per_heat: zod.number(),
          cost_per_tonne_tapped: zod.number(),
          cost_per_tonne_billets: zod.number(),
          display_cost_per_tonne_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
            )
            .describe(
              "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
            ),
          display_cost_per_tonne_electrical_energy: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
            )
            .describe(
              "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
            ),
          display_cost_per_tonne: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
            )
            .describe("The total cost per tonne to display in the frontend. "),
          cost_per_tonne_charged_materials: zod
            .number()
            .min(
              editHeatOverrideHistoryResponseOverrideMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
            ),
          cost_per_tonne_charged_electrical_energy: zod.number(),
          cost_per_tonne_charged: zod.number(),
        }),
        basket_summaries: zod.array(
          zod.object({
            chef_group_name: zod.string(),
            basket_number: zod
              .int()
              .gt(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
              ),
            recipe_mass: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemRecipeMassMin
              ),
            volume: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemVolumeMin
              ),
            fullness: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemFullnessMin
              ),
            min_fill_level: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMinFillLevelMin
              ),
            max_fill_level: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMaxFillLevelMin
              ),
            min_mass: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMinMassMin
              ),
            max_mass: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemMaxMassMin
              ),
            basket_volume: zod
              .number()
              .min(
                editHeatOverrideHistoryResponseOverrideMixSummaryOneBasketSummariesItemBasketVolumeMin
              ),
          })
        ),
      }),
      zod.null(),
    ]),
  }),
  charge_deltas: zod
    .union([
      zod.array(
        zod.object({
          basket_number: zod.int(),
          material_deltas: zod
            .array(
              zod.object({
                material_name: zod.string(),
                mass_delta_per_heat: zod
                  .number()
                  .describe(
                    "Signed change to the material's mass in the charge of each heat, in tenant mass units"
                  ),
              })
            )
            .min(1)
            .max(
              editHeatOverrideHistoryResponseChargeDeltasOneItemMaterialDeltasMax
            ),
        })
      ),
      zod.null(),
    ])
    .describe(
      "Material changes from the replaced mix, per charge; null unless the tenant enters overrides as deltas"
    ),
});

/**
 * @summary List Heat Override Recipes Endpoint
 */
export const ListHeatOverrideRecipesParams = zod.object({
  tenant_name: zod.string(),
});

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsRecipeMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsScrapMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsDriMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsTappedMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsTargetTappedMassLowerMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsBilletMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsYieldPercentMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsYieldPercentBilletsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsDisplayProducedMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsDisplayYieldPercentMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemWeightPercentScaleMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerHeatMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostDisplayCostPerTonneMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemRecipeMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemVolumeMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemFullnessMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMinFillLevelMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMinMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMaxMassMin = 0;

export const listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemBasketVolumeMin = 0;

export const ListHeatOverrideRecipesResponse = zod.object({
  items: zod.array(
    zod.object({
      fixed_mix_set_id: zod.int(),
      name: zod
        .string()
        .describe("Operator-facing name of the pre-approved override recipe"),
      mix_id: zod.int(),
      mix: zod
        .object({
          baskets: zod.array(
            zod.object({
              basket_number: zod.int(),
              layers: zod.array(
                zod.object({
                  material_name: zod.string(),
                  quantity: zod.object({
                    value: zod.number(),
                    unit: zod
                      .enum(["mass", "ratio", "grab"])
                      .describe(
                        "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                      ),
                  }),
                  layer_number: zod.int(),
                  layer_group_id: zod
                    .union([zod.int(), zod.null()])
                    .optional()
                    .describe(
                      "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
                    ),
                })
              ),
            })
          ),
          furnace: zod.array(
            zod.object({
              material_name: zod.string(),
              quantity: zod.object({
                value: zod.number(),
                unit: zod
                  .enum(["mass", "ratio", "grab"])
                  .describe(
                    "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
                  ),
              }),
            })
          ),
          thresholds: zod.union([
            zod.array(
              zod.object({
                material_name: zod.string(),
                upper: zod.union([zod.number(), zod.null()]),
                lower: zod.union([zod.number(), zod.null()]),
                unit: zod
                  .enum(["grabs", "mass", "fraction", "ratio_tolerance"])
                  .describe(
                    "Units for mix material strike thresholds.\n\nGRABS: Absolute lift-count bounds\nMASS: Absolute mass bounds\nFRACTION: Bounds on the material's share of the total charge\nRATIO_TOLERANCE: Allowed deviation of the material's lift ratio (to the\n    normalisation material) from the mix's own planned ratio"
                  ),
              })
            ),
            zod.null(),
          ]),
          id: zod.int(),
          basket_totals: zod.array(
            zod.object({
              material_name: zod.string(),
              mass: zod.number(),
            })
          ),
          summary: zod.union([
            zod.object({
              physics: zod.object({
                recipe_mass: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsRecipeMassMin
                  ),
                scrap_mass: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsScrapMassMin
                  ),
                dri_mass: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsDriMassMin
                  ),
                tapped_mass: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsTappedMassMin
                  ),
                target_tapped_mass_lower: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsTargetTappedMassLowerMin
                  ),
                billet_mass: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsBilletMassMin
                  ),
                yield_percent: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsYieldPercentMin
                  ),
                yield_percent_billets: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsYieldPercentBilletsMin
                  ),
                display_produced_mass: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsDisplayProducedMassMin
                  )
                  .describe(
                    "The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant "
                  ),
                display_yield_percent: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOnePhysicsDisplayYieldPercentMin
                  )
                  .describe(
                    "The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant"
                  ),
              }),
              chemistry: zod.array(
                zod.object({
                  constraint_name: zod.string(),
                  ordering: zod.int(),
                  weight_percent_loc: zod.number(),
                  weight_percent_scale: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemWeightPercentScaleMin
                    ),
                  steel_grade_risks: zod.array(
                    zod.object({
                      steel_grade_id: zod.int(),
                      weight_percent_min_tolerance: zod.union([
                        zod
                          .number()
                          .min(
                            listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMinToleranceOneMin
                          ),
                        zod.null(),
                      ]),
                      weight_percent_max_tolerance: zod
                        .number()
                        .min(
                          listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemWeightPercentMaxToleranceMin
                        ),
                      expected_over_tolerance_rate_percent: zod
                        .number()
                        .min(
                          listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedOverToleranceRatePercentMin
                        ),
                      expected_under_tolerance_rate_percent: zod
                        .number()
                        .min(
                          listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemExpectedUnderToleranceRatePercentMin
                        ),
                      warning_level_failure_rate_percent: zod
                        .number()
                        .min(
                          listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemWarningLevelFailureRatePercentMin
                        ),
                      error_level_failure_rate_percent: zod
                        .number()
                        .min(
                          listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemSteelGradeRisksItemErrorLevelFailureRatePercentMin
                        ),
                    })
                  ),
                  quantiles: zod.array(
                    zod.object({
                      quantile: zod
                        .number()
                        .min(
                          listHeatOverrideRecipesResponseItemsItemMixSummaryOneChemistryItemQuantilesItemQuantileMin
                        ),
                      weight_percent: zod.number(),
                    })
                  ),
                })
              ),
              cost: zod.object({
                cost_per_heat_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerHeatMaterialsMin
                  ),
                cost_per_heat_electrical_energy: zod.number(),
                cost_per_tonne_tapped_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerTonneTappedMaterialsMin
                  ),
                cost_per_tonne_tapped_electrical_energy: zod.number(),
                cost_per_tonne_billets_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerTonneBilletsMaterialsMin
                  ),
                cost_per_tonne_billets_electrical_energy: zod.number(),
                cost_per_heat: zod.number(),
                cost_per_tonne_tapped: zod.number(),
                cost_per_tonne_billets: zod.number(),
                display_cost_per_tonne_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostDisplayCostPerTonneMaterialsMin
                  )
                  .describe(
                    "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                  ),
                display_cost_per_tonne_electrical_energy: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostDisplayCostPerTonneElectricalEnergyMin
                  )
                  .describe(
                    "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                  ),
                display_cost_per_tonne: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostDisplayCostPerTonneMin
                  )
                  .describe(
                    "The total cost per tonne to display in the frontend. "
                  ),
                cost_per_tonne_charged_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostCostPerTonneChargedMaterialsMin
                  ),
                cost_per_tonne_charged_electrical_energy: zod.number(),
                cost_per_tonne_charged: zod.number(),
              }),
              cost_per_target_mass: zod.object({
                cost_per_heat_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerHeatMaterialsMin
                  ),
                cost_per_heat_electrical_energy: zod.number(),
                cost_per_tonne_tapped_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerTonneTappedMaterialsMin
                  ),
                cost_per_tonne_tapped_electrical_energy: zod.number(),
                cost_per_tonne_billets_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerTonneBilletsMaterialsMin
                  ),
                cost_per_tonne_billets_electrical_energy: zod.number(),
                cost_per_heat: zod.number(),
                cost_per_tonne_tapped: zod.number(),
                cost_per_tonne_billets: zod.number(),
                display_cost_per_tonne_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMaterialsMin
                  )
                  .describe(
                    "The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant"
                  ),
                display_cost_per_tonne_electrical_energy: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneElectricalEnergyMin
                  )
                  .describe(
                    "The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant"
                  ),
                display_cost_per_tonne: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassDisplayCostPerTonneMin
                  )
                  .describe(
                    "The total cost per tonne to display in the frontend. "
                  ),
                cost_per_tonne_charged_materials: zod
                  .number()
                  .min(
                    listHeatOverrideRecipesResponseItemsItemMixSummaryOneCostPerTargetMassCostPerTonneChargedMaterialsMin
                  ),
                cost_per_tonne_charged_electrical_energy: zod.number(),
                cost_per_tonne_charged: zod.number(),
              }),
              basket_summaries: zod.array(
                zod.object({
                  chef_group_name: zod.string(),
                  basket_number: zod
                    .int()
                    .gt(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemBasketNumberExclusiveMin
                    ),
                  recipe_mass: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemRecipeMassMin
                    ),
                  volume: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemVolumeMin
                    ),
                  fullness: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemFullnessMin
                    ),
                  min_fill_level: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMinFillLevelMin
                    ),
                  max_fill_level: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMaxFillLevelMin
                    ),
                  min_mass: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMinMassMin
                    ),
                  max_mass: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemMaxMassMin
                    ),
                  basket_volume: zod
                    .number()
                    .min(
                      listHeatOverrideRecipesResponseItemsItemMixSummaryOneBasketSummariesItemBasketVolumeMin
                    ),
                })
              ),
            }),
            zod.null(),
          ]),
        })
        .describe("The basket recipe the override deploys"),
      steel_grades: zod
        .union([zod.array(zod.string()), zod.null()])
        .describe("The steel grades this recipe can be deployed for"),
    })
  ),
});

/**
 * @summary Revise Heat Override Recipe Endpoint
 */
export const ReviseHeatOverrideRecipeParams = zod.object({
  tenant_name: zod.string(),
  fixed_mix_set_id: zod.int(),
});

export const ReviseHeatOverrideRecipeBody = zod.object({
  mix_id: zod.int(),
  baskets: zod.array(
    zod.object({
      basket_number: zod.int(),
      layers: zod.array(
        zod.object({
          material_name: zod.string(),
          quantity: zod.object({
            value: zod.number(),
            unit: zod
              .enum(["mass", "ratio", "grab"])
              .describe(
                "Units for measuring material quantities.\n\nMASS: Absolute mass measurements (e.g., tons)\nRATIO: Relative proportion to total grabs in a series\nGRAB: Simple additive count of grabs"
              ),
          }),
          layer_number: zod.int(),
          layer_group_id: zod
            .union([zod.int(), zod.null()])
            .optional()
            .describe(
              "Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group."
            ),
        })
      ),
    })
  ),
});

export const ReviseHeatOverrideRecipeResponse = zod.object({
  fixed_mix_set_id: zod.int(),
  mix_id: zod.int(),
});

/**
 * @summary List Heat Override Reasons Endpoint
 */
export const ListHeatOverrideReasonsParams = zod.object({
  tenant_name: zod.string(),
});

export const ListHeatOverrideReasonsResponse = zod.object({
  reasons: zod.array(
    zod.object({
      reason: zod.string(),
      subreasons: zod.array(zod.string()),
    })
  ),
});

/**
 * @summary Cancel Heat Override Endpoint
 */
export const CancelHeatOverrideParams = zod.object({
  tenant_name: zod.string(),
  override_id: zod.int(),
});

export const CancelHeatOverrideResponse = zod.void();

/**
 * @summary Cancel Historical Heat Override Endpoint
 */
export const CancelHistoricalHeatOverrideParams = zod.object({
  tenant_name: zod.string(),
  override_id: zod.int(),
});

export const CancelHistoricalHeatOverrideResponse = zod.void();

/**
 * @summary Get Live Recipe
 */
export const GetLiveRecipeParams = zod.object({
  tenant_name: zod.string(),
});

export const getLiveRecipeResponseOneMaterialsItemRecipeMassMin = 0;

export const getLiveRecipeResponseOneMaterialsItemPercentageMin = 0;
export const getLiveRecipeResponseOneMaterialsItemPercentageMax = 100;

export const getLiveRecipeResponseOneTotalRecipeMassMin = 0;

export const GetLiveRecipeResponse = zod.union([
  zod
    .object({
      mix_name: zod.string().describe("Name of the mix/recipe"),
      plan_id: zod.int().describe("Database ID of the optimisation result set"),
      mix_id: zod.int().describe("Database ID of the mix"),
      next_heat_id: zod.int().describe("Heat ID of the next upcoming heat"),
      upcoming_heat_count: zod
        .int()
        .min(1)
        .describe("Number of upcoming heats using this recipe"),
      charge_schedule_id: zod
        .string()
        .describe("Plant charge schedule ID assigned to the heats"),
      materials: zod
        .array(
          zod
            .object({
              material_name: zod.string(),
              material_id: zod.int(),
              recipe_mass: zod
                .number()
                .min(getLiveRecipeResponseOneMaterialsItemRecipeMassMin)
                .describe("Mass of this material per heat in tonnes"),
              percentage: zod
                .number()
                .min(getLiveRecipeResponseOneMaterialsItemPercentageMin)
                .max(getLiveRecipeResponseOneMaterialsItemPercentageMax)
                .describe("Percentage of total recipe mass"),
              heats_until_depletion: zod
                .union([zod.int(), zod.null()])
                .describe(
                  "Number of heats until this material is depleted from inventory. Null if inventory data is not available."
                ),
            })
            .describe(
              "A material in the live recipe with its mass, percentage, and depletion info."
            )
        )
        .describe("List of materials in the recipe with depletion info"),
      total_recipe_mass: zod
        .number()
        .min(getLiveRecipeResponseOneTotalRecipeMassMin)
        .describe("Total mass of the recipe per heat in tonnes"),
    })
    .describe("Live recipe assigned to upcoming heats."),
  zod.null(),
]);
